<template>
    <div v-if="isValid('TouchInvoiceTemplate2')">
        <div v-if="isDayAlreadyStart" class="grey_color">
            <div class="container-fluid" v-bind:key="rander" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                <div class="row border-bottom" style="height:45px;">
                    <div class="col-2 white_color" v-if="!isPay">
                        <div style="padding-top:10px;padding-left:19px;text-align:left">
                            <img src="/noblepos-logo---3psd.png">
                        </div>
                    </div>

                <div class="col-5 white_color">
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                            <div v-if="!isInvoiceSearch" class="form-group mt-1">
                                <multiselect v-model="selectedProductValue"
                                             id="ajax"
                                             @search-change="getProduct"
                                             @input="UpdateProductData"
                                             :options="productOption"
                                             :multiple="false"
                                             :internal-search="false"
                                             :searchable="true"
                                             :loading="isLoading"
                                             track-by="name"
                                             :clear-on-select="false"
                                             :show-labels="false"
                                             label="name"
                                             class="inv_search"
                                             v-bind:placeholder="$t('TouchScreenForBarcodeUser.TypeSearch')" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left ' : 'arabicLanguage '">
                                </multiselect>
                            </div>

                            <div v-else class="form-group mt-1">
                                <multiselect v-model="selectedValue"
                                             id="ajax"
                                             @search-change="asyncFind"
                                             @input="getPostInvoiceDetail(selectedValue.id)"
                                             :options="saleList"
                                             :multiple="false"
                                             :internal-search="false"
                                             :searchable="true"
                                             :loading="isLoading"
                                             track-by="name"
                                             :clear-on-select="false"
                                             :show-labels="false"
                                             label="name"
                                             :preselect-first="true"
                                             class="inv_search"
                                             v-bind:placeholder="$t('TouchScreenForBarcodeUser.SearchInvoice')" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left ' : 'arabicLanguage '">
                                </multiselect>
                            </div>
                        </div>

                        </div>
                    </div>

                    <div class="col-5 white_color">
                        <div class="row">
                            <div v-if="!isInvoiceSearch" class="col-lg-3 col-md-3 col-sm-3 col-3" style="padding-top: 13px;">
                                <span v-on:click="serachInvoiceByBarcode(true)" style="cursor: pointer;">
                                    <img src="/sale-normal.png" alt="sale-refund" />
                                </span>
                            </div>

                            <div v-else class="col-lg-3 col-md-3 col-sm-3 col-3" style="padding-top: 13px;">
                                <span v-on:click="serachInvoiceByBarcode(false)" style="cursor: pointer;">
                                    <img src="/sale-refund.png" alt="sale-refund" />
                                </span>
                            </div>

                            <div class="col-lg-9 col-md-9 col-sm-9 col-9 text-right">
                                <div class="form-group has-search text-right">
                                    <button class="btn btn-primary btn-sm ml-1 mr-1"
                                            v-if="isValid('CanAddTouchQuickItem')"
                                            v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? '' :'font-size:15px !important; font-weight:bold !important;letter-spacing: 1px;'"
                                            v-on:click="addNewProduct">
                                        {{ $t('TouchScreenForBarcodeUser.AddItem') }}

                                    </button>
                                    <button class="btn btn-danger btn-sm"
                                            v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? '' :'font-size:15px !important; font-weight:bold !important;letter-spacing: 1px;'"
                                            v-on:click="goToSale">
                                        {{ $t('TouchScreenForBarcodeUser.Close') }}

                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" style="height:6vh;">
                    <div class="col-lg-2 col-md-2 col-sm-2 col-2 border-right grey_color" style="padding-top:8px;">
                        <span>{{sale.date}} </span>
                    </div>

                    <div class="col-lg-2 col-md-2 col-sm-2 col-2 border-right grey_color text-center" style="padding-top:8px;">
                        <a href="javascript:void(0)" v-on:click="openWalkModel" v-if="isValid('CanSelectCustomer')">   {{sale.cashCustomer}}</a>
                        <span v-else>   {{sale.cashCustomer}}</span>
                    </div>

                    <div class="col-lg-2 col-md-2 col-sm-2 col-2 border-right grey_color text-center" style="padding-top:8px;">
                        <span> Invoice No : {{sale.registrationNo}}</span>
                    </div>

                <div class="col-lg-2 col-md-2 col-sm-2 col-2 border-right grey_color text-center" style="padding-top:8px;">
                    {{ $t('TouchScreenForBarcodeUser.CounterNo') }} {{counterCode}}
                </div>

                <div class="col-lg-2 col-md-2 col-sm-2 col-2 border-right grey_color text-center" style="padding-top:8px;">
                    {{ $t('TouchScreenForBarcodeUser.User') }}{{loginUserName}}
                </div>

                    <div class="col-lg-2 col-md-2 col-sm-2 col-2 border-right grey_color text-right" style="padding-top:8px;">
                        {{dayStartTime}}
                    </div>
                </div>


                <div class="row" style="height: 87vh;">

                    <div class="col-lg-7 col-md-7 col-sm-7 col-7 border-bottom" style="height: 87vh;">

                    <div class="card" style="border-radius: 0;margin-bottom: 5px !important;">
                        <div style="height: 47vh; overflow: auto;padding:8px;">
                            <table class="table add_table_list_bg text-left" style="table-layout: fixed;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                <thead class="m-0" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                    <tr class="tbl_border">
                                        <th style="width: 5%;">#</th>
                                        <th class="text-center" style="width: 35%;">
                                            {{ $t('TouchScreenForBarcodeUser.Product') }}
                                        </th>
                                        <th v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-center' : 'text-right'" style="width: 15%;">
                                            {{ $t('TouchScreenForBarcodeUser.UnitPrice') }}
                                        </th>
                                        <th style="width: 26px;" class=""></th>
                                        <th class="text-center" style="width: 10%;">
                                            {{ $t('TouchScreenForBarcodeUser.Quantity') }}
                                        </th>
                                        <th style="width: 26px;" class=""></th>
                                        <th class="text-right" style="width: 25%;">
                                            {{ $t('TouchScreenForBarcodeUser.LineTotal') }}
                                        </th>
                                        <th style="width: 10%;"></th>
                                    </tr>
                                </thead>
                                <tbody id="sale-item" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                    <template v-for="(prod, index) in saleProducts">
                                        <tr class="tbl_border" :key="itemRender+index" v-bind:class="{'bg-danger':prod.outOfStock}" style="border-bottom: 1px solid #d6d6d6; ">
                                            <td>{{index+1}}</td>
                                            <td>
                                                <span>
                                                    {{($i18n.locale == 'en' ||isLeftToRight())? products.find(x => x.id == prod.productId).englishName!=''? products.find(x => x.id == prod.productId).englishName : products.find(x => x.id == prod.productId).arabicName :    products.find(x => x.id == prod.productId).arabicName!=''? products.find(x => x.id == prod.productId).arabicName : products.find(x => x.id == prod.productId).englishName}}
                                                </span>
                                                <span v-if="products.find(x => x.id == prod.productId).promotionOffer!=undefined && products.find(x => x.id == prod.productId).promotionOffer.fixedDiscount > 0" class="badge badge-pill badge-success">
                                                    {{currency}} {{(products.find(x => x.id == prod.productId).promotionOffer.fixedDiscount).toFixed(3).slice(0,-1)}}, ({{products.find(x => x.id == prod.productId).promotionOffer.stockLimit - products.find(x => x.id == prod.productId).promotionOffer.quantityOut}})
                                                </span>
                                                <span v-if="products.find(x => x.id == prod.productId).promotionOffer!=undefined && products.find(x => x.id == prod.productId).promotionOffer.discountPercentage > 0" class="badge badge-pill badge-success">
                                                    {{(products.find(x => x.id == prod.productId).promotionOffer.discountPercentage).toFixed(3).slice(0,-1)}}%, ({{products.find(x => x.id == prod.productId).promotionOffer.stockLimit - products.find(x => x.id == prod.productId).promotionOffer.quantityOut}})
                                                </span>
                                                <span v-if="products.find(x => x.id == prod.productId).bundleCategory != undefined" class="badge badge-pill badge-success">
                                                    {{products.find(x => x.id == prod.productId).bundleCategory.buy}} + {{products.find(x => x.id == prod.productId).bundleCategory.get}}, ({{products.find(x => x.id == prod.productId).bundleCategory.stockLimit - products.find(x => x.id == prod.productId).bundleCategory.quantityOut}})
                                                </span>
                                            </td>

                                                <td v-on:dblclick="counter += 1, openmodel('unitPrice'+index)" v-if="!changePriceDuringSale">
                                                    <span v-bind:style="isPay ? 'pointer-events: none;' : '' ">
                                                        <decimal-to-fixed :color="true" :barcodescreen="true" disable="(isAuthour.changePriceDuringSale && isAuthour.column==('unitPrice'+index))==true?'true':'false'" v-model="prod.unitPrice" v-bind:salePriceCheck="false" v-on:input="updateLineTotal(prod.unitPrice, 'unitPrice', prod)" />
                                                    </span>

                                                </td>
                                                <td v-else>
                                                    <span v-bind:style="isPay ? 'pointer-events: none;' : '' ">
                                                        <decimal-to-fixed :color="true" :barcodescreen="true" v-model="prod.unitPrice" v-bind:salePriceCheck="false" v-on:input="updateLineTotal(prod.unitPrice, 'unitPrice', prod)" />
                                                    </span>
                                                </td>

                                                <td v-bind:style="isPay ? 'pointer-events: none;' : '' ">  <span v-on:click="quantityIncrease(prod.productId)">   <img src="/images/qty-plus.svg "></span></td>
                                                <td>
                                                    <input v-model="prod.quantity"
                                                           type="number"
                                                           v-bind:disabled="isPay"
                                                           @focus="$event.target.select()"
                                                           class="form-control input-border text-center qty-input"
                                                           @keyup="updateLineTotal($event.target.value, 'quantity', prod)" />

                                                </td>
                                                <td v-bind:style="isPay ? 'pointer-events: none;' : '' ">  <span v-on:click="quantityDecrease(prod.productId)"><img src="/images/qty-minus.svg "></span></td>

                                                <td class="text-right">
                                                    {{parseFloat(prod.lineTotal).toFixed(3).slice(0,-1) | formatAmount}}
                                                </td>
                                                <td v-bind:style="isPay ? 'pointer-events: none;' : '' ">
                                                    <button @click="removeProduct(prod.rowId)"
                                                            title="Remove Item"
                                                            class="btn btn-danger btn-sm btn-round btn-icon float-right">
                                                        <i class="nc-icon nc-simple-remove"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>

                        </div>

                    <div class="row" style="position: absolute; bottom: 0; width: 100%;">
                        <div class="col-12">
                            <div class="card" style="border-radius: 0;margin-bottom:0;">
                                <table class="table table-borderless inv_detail_padd" style="font-size:14px;font-weight:bold;width:100%" v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? '' : 'direction: rtl; '">
                                    <tr>
                                        <td style="width:30%;">{{ $t('TouchScreenForBarcodeUser.NoItem') }}</td>
                                        <td style="width:14%;" v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-align:right;' : 'text-align:left;'">{{summary.item}}</td>
                                        <td style="width:2%;"></td>
                                        <td style="width:30%;">{{ $t('TouchScreenForBarcodeUser.TotalQty') }}</td>
                                        <td style="width:14%;" v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-align:right;' : 'text-align:left;'">{{ summary.qty}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('TouchScreenForBarcodeUser.Total') }}</td>
                                        <td v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-align:right;' : 'text-align:left;'">{{parseFloat(taxMethod =='Exclusive' ?  summary.total: (summary.total-summary.vat)).toFixed(3).slice(0,-1) | formatAmount}}</td>
                                        <td></td>
                                        <td>{{ $t('TouchScreenForBarcodeUser.Disc') }}</td>
                                        <td v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-align:right;' : 'text-align:left;'">{{parseFloat(summary.discount).toFixed(3).slice(0,-1) | formatAmount}}</td>
                                    </tr>
                                    <tr v-if="summary.bundleAmount > 0">
                                        <td colspan="4">{{ $t('TouchScreenForBarcodeUser.BundleAmount') }}</td>
                                        <td v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-align:right;' : 'text-align:left;'">{{parseFloat(summary.bundleAmount).toFixed(3).slice(0,-1) | formatAmount}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('TouchScreenForBarcodeUser.TotalVat') }}</td>
                                        <td v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-align:right;' : 'text-align:left;'"> {{ (parseFloat(summary.vat)+summary.inclusiveVat).toFixed(3).slice(0,-1) | formatAmount }}</td>
                                        <td></td>
                                        <td> {{ $t('TouchScreenForBarcodeUser.TotalWithVat') }}</td>
                                        <td v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-align:right;' : 'text-align:left;'">{{  parseFloat(summary.withVat).toFixed(3).slice(0,-1) | formatAmount }}</td>
                                    </tr>
                                </table>
                            </div>

                            <h6 style="color:#3178F6;margin-top:10px;margin-bottom:2px;">{{ $t('TouchScreenForBarcodeUser.PaymentDetails') }}</h6>
                            <div class="card" style="border-radius: 0; margin-bottom:0;height:75px;">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-6" v-for="(payment, index) in sale.salePayment.paymentTypes" :key="index">
                                            <p class="m-0" style="font-size:16px;">
                                                {{payment.name}} <span v-if="payment.paymentType=='OtherCurrency'">({{ $t('TouchScreenForBarcodeUser.Amount') }}={{payment.otherAmount}}, {{ $t('TouchScreenForBarcodeUser.Rate') }}={{payment.rate}})</span> : {{payment.amount | formatAmount}}
                                                <span class="float-right" style="cursor:pointer;" @click="removeFromPaymentList(index)"><i class="nc-icon nc-simple-remove text-danger"></i></span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>



                                <div class="row">
                                    <div class="col-3" style="padding-right: 4px;">
                                        <button class="btn btn-primary btn-block  mr-2"
                                                v-on:click="openHoldModel"
                                                style="border-radius:3px;"
                                                v-if="isValid('CanHoldTouchInvoices')"
                                                v-bind:disabled="$v.$invalid || saleProducts.filter(x => x.unitPrice=='').length > 0 || saleProducts.filter(x => x.quantity=='' || x.quantity==0).length > 0 || isPay">
                                            <span v-if="sale.id == '00000000-0000-0000-0000-000000000000'">
                                                {{ $t('TouchScreenForBarcodeUser.Hold') }}
                                            </span>
                                            <span v-else>

                                                {{ $t('TouchScreenForBarcodeUser.HoldAndUpdate') }}
                                            </span>
                                        </button>
                                    </div>

                                    <div class="col-3" style="padding-right: 4px;padding-left: 4px;">
                                        <button class="btn btn-primary btn-block  mr-2"
                                                v-on:click="openUnHoldModel"
                                                style="border-radius:3px;"
                                                v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? '' :'font-size:15px !important; font-weight:bold !important;letter-spacing: 1px;'"
                                                v-bind:disabled="isPay "
                                                v-if="isValid('CanHoldTouchInvoices')">
                                            <span v-if="sale.id == '00000000-0000-0000-0000-000000000000'">
                                                {{ $t('TouchScreenForBarcodeUser.UnHold') }}
                                            </span>
                                            <span v-else>
                                                {{ $t('TouchScreenForBarcodeUser.UnHold') }}
                                            </span>
                                        </button>
                                    </div>

                                    <!--<div class="col-3">
                                        <button class="btn btn-danger btn-block  mr-2"
                                                v-bind:disabled="isPay "
                                                v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? '' :'font-size:15px !important; font-weight:bold !important;letter-spacing: 1px;'"
                                                v-on:click="goToSale">
                                            {{ $t('TouchScreenForBarcodeUser.Close') }}

                                        </button>
                                    </div>-->
                                    <div class="col-3" style="padding-right: 4px;padding-left: 4px;">
                                        <button class="btn hoverColour btn-block  mr-2 "
                                                style="border:1px solid rgb(183, 41, 83);"
                                                v-bind:style=" ($i18n.locale == 'en' ||isLeftToRight()) ? 'background-color:#b72953' :'background-color:#b72953;font-size:15px !important; font-weight:bold !important;letter-spacing: 1px;'"
                                                v-on:click="Reset(false)">
                                            {{ $t('TouchScreenForBarcodeUser.Reset') }}
                                        </button>
                                    </div>
                                    <div class="col-3" style="padding-left: 4px;">
                                        <button class="btn  btn-primary mr-2 btn-block"
                                                style="border-radius:3px;"
                                                 v-if="isValid('CanPrintTouchInvoice')"
                                                v-on:click="saveSale('Paid', true)" v-bind:disabled="!isPaymentValid || $v.$invalid || saleProducts.filter(x => x.outOfStock).length > 0">
                                            {{ $t('TouchScreenForBarcodeUser.SaveAndPrint') }}
                                        </button>
                                        <button class="btn  btn-primary mr-2 btn-block"
                                                style="border-radius:3px;"
                                                v-else
                                                v-on:click="saveSale('Paid', false)" v-bind:disabled="!isPaymentValid || $v.$invalid || saleProducts.filter(x => x.outOfStock).length > 0">
                                            {{ $t('TouchScreenForBarcodeUser.SaveSale') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-5 col-md-5 col-sm-5 col-5" style="height: 87vh;">
                        <div class="card" style="border-radius: 0;margin-bottom: 5px !important;">
                            <div style="height: 325px;">
                                <div class="row" v-bind:style="[sale.salePayment.paymentType==='' ? {'pointer-events': 'none'} : {'background': '#FFF'}]">
                                    <div class="col-9">
                                        <div class="row" style="margin-left: 0; margin-right: 0;margin-top:8px;margin-bottom:8px;">
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                                <div>
                                                    <input v-model="calculateValueShow" class="form-control" :ref="'calInput'" style="background-color: rgba(49, 120, 246, 0.1);height:45px!important;max-height:45px!important; border-radius: 3px; border: 1px solid #3178F6; box-sizing: border-box; font-size: 18px;" @keypress="NumberKey" @keyup="BackspaceKey" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row calculator-wraper" style="margin-left: 0; margin-right: 0;">
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4" style="padding-right: 4px;">
                                                <button class="btn btn-primary btn-block btn-lg   mt-1 mb-1" @click="calculatorValuaCalculation('7')">7</button>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4" style="padding-right: 4px;padding-left: 4px;">
                                                <button class="btn btn-primary btn-block btn-lg   mt-1 mb-1" @click="calculatorValuaCalculation('8')">8</button>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4" style="padding-left: 4px;">
                                                <button class="btn btn-primary btn-block btn-lg   mt-1 mb-1" @click="calculatorValuaCalculation('9')">9</button>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4" style="padding-right: 4px;">
                                                <button class="btn btn-primary btn-block btn-lg  mt-1 mb-1" @click="calculatorValuaCalculation('4')">4</button>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4" style="padding-right: 4px;padding-left: 4px;">
                                                <button class="btn btn-primary btn-block btn-lg   mt-1 mb-1" @click="calculatorValuaCalculation('5')">5</button>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4" style="padding-left: 4px;">
                                                <button class="btn btn-primary btn-block btn-lg   mt-1 mb-1" @click="calculatorValuaCalculation('6')">6</button>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4" style="padding-right: 4px;">
                                                <button class="btn btn-primary btn-block btn-lg  mt-1 mb-1" @click="calculatorValuaCalculation('1')">1</button>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4" style="padding-right: 4px;padding-left: 4px;">
                                                <button class="btn btn-primary btn-block btn-lg   mt-1 mb-1" @click="calculatorValuaCalculation('2')">2</button>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4" style="padding-left: 4px;">
                                                <button class="btn btn-primary btn-block btn-lg  mt-1 mb-1" @click="calculatorValuaCalculation('3')">3</button>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4" style="padding-right: 4px;">
                                                <button class="btn btn-primary btn-block btn-lg  mt-1 mb-1" @click="calculatorValuaCalculation('c')">C</button>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4" style="padding-right: 4px;padding-left: 4px;">
                                                <button class="btn btn-primary btn-block btn-lg  mt-1 mb-1" @click="calculatorValuaCalculation('0')">0</button>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4" style="padding-left: 4px;">
                                                <button class="btn btn-primary btn-block btn-lg  mt-1 mb-1" @click="calculatorValuaCalculation('.')">.</button>
                                            </div>
                                            <div class="col-lg-8 col-md-8 col-sm-8 col-8" style="padding-right: 4px;">
                                                <button class="btn btn-primary btn-block btn-lg   mt-1 mb-1" @click="calculatorValuaCalculation('back')"><i class="nc-icon nc-simple-remove"></i></button>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4" style="padding-left: 4px;">
                                                <button @click="addPayment(sale.salePayment.received, sale.salePayment.paymentType, sale.salePayment.paymentName)"
                                                        v-bind:disabled="!(sale.salePayment.paymentType=='OtherCurrency' && sale.otherCurrency.currencyId!=null && sale.salePayment.received > 0) && !(sale.salePayment.paymentType=='Bank' && sale.salePayment.paymentOptionId!=null && sale.salePayment.received > 0) && !(sale.salePayment.paymentType=='Cash' && sale.salePayment.received > 0)"
                                                        class="btn btn-block btn-lg  mt-1 mb-1" style="background-color:#44c47d !important;color:#ffffff;">
                                                    {{ $t('TouchScreenForBarcodeUser.Add') }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row denomination-wraper" style=" margin-right: 0;margin-top:8px;">
                                            <div style="padding-left:0;" class="col-lg-12 col-md-12 col-sm-12 col-12" v-for="item in denominationSetuplist.slice(0, 6)" :key="item.id">
                                                <button class="btn btn-primary btn-block btn-lg   mt-1 mb-1" @click="calculatorValuaCalculation(item.number, 'denomination')">{{item.number}}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card" style="border-radius: 0;margin-bottom: 5px !important;" v-if="sale.salePayment.dueAmount>=0">
                            <div class="card-body" style="padding: 8px 15px 8px 15px;">
                                <div v-bind:style="[saleProducts.length<=0 ? {'pointer-events': 'none'} : {'background': '#FFF'}]" class="card-body" style="background-color: #f6f6f6;padding: 8px 15px 8px 15px;">
                                    <div class="row">
                                        <div v-bind:class="cashVoucherAllow == 'true' ? 'col-lg-4' : 'col-lg-6'" style="padding-left: 4px; padding-right: 4px;">
                                            <div v-on:click="isPayment(togglePayCash)" v-bind:class="{ bg_color: sale.salePayment.paymentType=='Cash' }" class="mr-2 pay_bg_color" style="border: 1px solid #2d76f7; height: 35px; padding: 6px 2px 5px 2px; width: 100%; font-size: 15px; cursor: pointer; text-align: center;"><i class="fas fa-money-bill-alt"></i> {{ $t('TouchScreenForBarcodeUser.Cash') }}</div>
                                        </div>
                                        <div v-bind:class="cashVoucherAllow == 'true' ? 'col-lg-4' : 'col-lg-6'" style="padding-left: 4px; padding-right: 4px;">
                                            <div v-on:click="isPayment(toggleBank)" v-bind:class="{ bg_color: sale.salePayment.paymentType=='Bank' }" class="mr-2 pay_bg_color" style="border: 1px solid #2d76f7; height: 35px; padding: 6px 2px 5px 2px; width: 100%; font-size: 15px; cursor: pointer; text-align: center;"><i class="fas fa-money-bill-alt"></i> {{ $t('TouchScreenForBarcodeUser.Bank') }}</div>
                                        </div>
                                        <div class="col-4" v-if="cashVoucherAllow=='true' && isValid('CanAddCashVoucher')" style="padding-left: 4px; padding-right: 4px;">
                                            <div v-on:click="isPayment(togglePayVoucher)" v-bind:class="{ bg_color: sale.salePayment.paymentType=='CashVoucher' }" class="mr-2 pay_bg_color" style="border: 1px solid #2d76f7; height: 35px;  padding: 6px 2px 5px 2px; width: 100%; font-size: 15px; cursor: pointer; text-align: center;"><i class="fas fa-money-bill-alt"></i> {{ $t('TouchScreenForBarcodeUser.Voucher') }}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card-body" style="padding: 8px 15px 8px 15px; background-color: #f6f6f6; margin-top: 5px;" v-if="sale.salePayment.paymentType == 'Bank'">
                                    <div class="row">
                                        <div class="col-4 text-center" v-for="bank in bankList" v-bind:key="bank.id" style="padding-left: 4px; padding-right: 4px;">
                                            <div v-bind:class="{ bg_color: bank.id==bankId }" v-on:click="selectBank(bank.id,bank.name)" style="border: 1px solid #3178F61A;background-color:#3178F61A; padding: 5px; border-radius: 5px;font-weight: 600; cursor: pointer;font-size: 10px;">
                                                <div class="text-truncate" style="font-size:12px;">
                                                    <img src="Product.png" v-if="bank.image==null || bank.image=='' || bank.image==undefined" style="width: 40px; height: 25px;">
                                                    <img :src="'data:image/png;base64,' + bank.image" v-else style="width: 40px; height: 25px;">
                                                    <span class="text-truncate" v-if="($i18n.locale == 'en' ||isLeftToRight())"> {{ bank.name }}</span>
                                                    <span class="text-truncate" v-else> {{ bank.nameArabic }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            <div class="card-body" style="padding: 8px 15px 8px 15px; background-color: #f6f6f6; margin-top: 5px;" v-if="sale.salePayment.paymentType == 'CashVoucher'">
                                <div class="row">
                                    <div class="col-8 text-center">
                                        <input type="text" class="form-control"
                                               style="height: 37px;"
                                               @focus="FocusInput('voucher', $event)"
                                               v-model="sale.voucherNo" />
                                    </div>
                                    <div class="col-4 text-center">
                                        <button @click="VerifyCashVoucher()"
                                                class="btn btn-primary btn-block m-0">
                                            {{ $t('TouchScreenForBarcodeUser.Apply') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                        <div class="row" style=" bottom: 0; position: absolute;width:100%">
                            <div class="col-12">
                                <div class="card" style="border-radius: 0;margin-bottom: 5px !important;">

                                <div class="card-body" style="padding: 8px 15px 8px 15px;">
                                    <div class="row">
                                        <div class="col-6 mb-2">
                                            <div class="p-1" style="background-color: rgba(49, 120, 246, 0.1); border-radius: 0px; font-weight: 600; cursor: pointer; font-size: 10px;">
                                                <p style="margin:0;">{{ $t('TouchScreenForBarcodeUser.DueAmount') }}</p>
                                                <p style="margin:0; font-size:22px;line-height: 1;">{{sale.salePayment.dueAmount}}</p>
                                            </div>
                                        </div>
                                        <div class="col-6 mb-2">
                                            <div class="p-1" style="background-color: rgba(49, 120, 246, 0.1); border-radius: 0px; font-weight: 600; cursor: pointer; font-size: 10px;">
                                                <p style="margin:0;">{{ $t('TouchScreenForBarcodeUser.Received') }}</p>
                                                <p style="margin:0; font-size:22px;line-height: 1;">{{sale.salePayment.received}}</p>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="p-1" style="background-color: rgba(49, 120, 246, 0.1); border-radius: 0px; font-weight: 600; cursor: pointer; font-size: 10px;">
                                                <p style="margin:0;">{{ $t('TouchScreenForBarcodeUser.Balance') }} </p>
                                                <p style="margin:0; font-size:22px;line-height: 1;">{{sale.salePayment.balance}}</p>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="p-1" style="background-color:rgba(49, 120, 246, 0.1); border-radius: 0px;font-weight: 600; cursor: pointer;font-size: 10px;">
                                                <p style="margin:0;">{{ $t('TouchScreenForBarcodeUser.Change') }}</p>
                                                <p style="margin:0; font-size:22px;line-height: 1;">{{sale.salePayment.change}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <cash-voucher-report :printDetail="printDetailsCashVoucher" :isTouchScreen="TouchInvoice" :headerFooter="headerFooter" v-if="printDetailsCashVoucher.length != 0" v-bind:key="printRender" />
                <readymade-garments :printDetail="printDetailsPos" :saleReturnRegNo="saleReturnRegNo" :isDoublePrint="isDoublePrint" :saleId="saleId" :isTouchScreen="TouchInvoice" :headerFooter="headerFooter" v-if="printDetailsPos.length != 0 && printSize=='Thermal' && printTemplate=='Default'" v-bind:key="printRender" />
                <SalesThermalSaudiReports3 :printDetail="printDetailsPos" :saleReturnRegNo="saleReturnRegNo" :isDoublePrint="isDoublePrint" :saleId="saleId" :isTouchScreen="TouchInvoice" :headerFooter="headerFooter" v-if="printDetailsPos.length != 0 && printSize=='Thermal' && printTemplate=='RetailSaTemplate1'" v-bind:key="printRender" />
                <SalesThermalSaudiReports4 :printDetail="printDetailsPos" :saleReturnRegNo="saleReturnRegNo" :isDoublePrint="isDoublePrint" :saleId="saleId" :isTouchScreen="TouchInvoice" :headerFooter="headerFooter" v-if="printDetailsPos.length != 0 && printSize=='Thermal' && printTemplate=='RetailSaTemplate2'" v-bind:key="printRender" />
                <saleInvoice :color="true" :printDetails="printDetails" :isTouchScreen="TouchInvoice" :headerFooter="headerFooter" v-if="printDetails.length != 0 && printTemplate=='Default'" v-bind:key="printRender" />
                <saleInvoice-template-one :printDetails="printDetails" :isTouchScreen="TouchInvoice" :headerFooter="headerFooter" v-if="printDetails.length != 0 && printTemplate=='Template1'" v-bind:key="printRender" />
                <saleinvoice-dotMatrixprint :printDetails="printDetails" :isTouchScreen="TouchInvoice" :headerFooter="headerFooter" v-if="printDetails.length != 0 && printTemplate=='Template2'" v-bind:key="printRender" />

                <walk-customer-modal :sale="newsale"
                                     :show="walkcustomer"
                                     v-if="walkcustomer"
                                     @close="WalkIn" />
                <hold-modal :sale="newsale"
                            :show="hold"
                            v-if="hold"
                            @close="holdCustomer"
                            @saveSale="saveSale" />
                <unhold-modal :sale="newsale"
                              :show="unhold"
                              v-if="unhold"
                              @close="UnholdCustomer"
                              @EditTOuchInvocie="EditTOuchInvocie" />

                <return-item-model :sale="postInvoiceDetail"
                                   :show="returnItem"
                                   v-if="returnItem"
                                   @close="returnItemModelClose"
                                   @EditTOuchInvocie="EditTOuchInvocie" />
                <cashcounterdetail @close="show1 = false, isDayStart()"
                                   :counterCode="counterCode"
                                   :cashInHand="cashInHand"
                                   :openingCash="openingCash"
                                   :bank="bank"
                                   :dayStartId="dayStartId"
                                   :expense="expense"
                                   :counterId="counterId"
                                   :show="show1"
                                   v-if="show1"
                                   :type="type" />

                <quickProductItem :product="newProduct"
                                  :show="showProduct"
                                  v-if="showProduct"
                                  @closeOnSave="onCloseQuickProduct"
                                  @close="showProduct = false"
                                  :type="type" />
                <!--<barcodeScannerComponent ></barcodeScannerComponent>-->

            </div>
        </div>
        <div v-else class="container" style="background-color: #F4F6FC ;">
            <div class="col-lg-6 col-sm-6 ml-auto mr-auto p-4">
                <div class="card  text-center p-4">
                    <h4 class="">{{ $t('TouchScreenForBarcodeUser.FirstStartInvoice') }}</h4>
                    <div class="row">
                        <div class="col-md-6">
                            <button class="btn btn-outline-danger btn-block  mr-2" v-on:click="goToSale">
                                <i class="fas fa-arrow-circle-left fa-lg"></i> {{ $t('TouchScreenForBarcodeUser.Close') }}
                            </button>
                        </div>
                        <div class="col-md-6" v-if="bankDetail">
                            <router-link :to="{path: '/WholeSaleDay', query: { token_name:'DayStart_token', fromDashboard:'true' } }"><a href="javascript:void(0)" class="btn btn-outline-danger btn-block ">{{ $t('TouchScreenForBarcodeUser.DayStart') }}</a></router-link>
                        </div>
                        <div class="col-md-6" v-else>
                            <router-link :to="{path: '/dayStart', query: { token_name:'DayStart_token', fromDashboard:'true' } }" ><a href="javascript:void(0)" class="btn btn-outline-danger btn-block ">{{ $t('TouchScreenForBarcodeUser.DayStart') }}</a></router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else> <acessdenied></acessdenied></div>

</template>
<script>
    import moment from "moment";
    import clickMixin from '@/Mixins/clickMixin'
    import "vue-loading-overlay/dist/vue-loading.css";
    import { required, requiredIf } from "vuelidate/lib/validators";
    import Multiselect from "vue-multiselect";
    export default {
        name: "TouchInvoice",
        components: {
            Multiselect,
        },
        mixins: [clickMixin],
        data: function () {
            return {
                barcode:'',
                productOption: [],
                isLoading: false,
                bankDetail: false,
                decimalQuantity: false,
                dayStartId: '00000000-0000-0000-0000-000000000000',
                counterId: '00000000-0000-0000-0000-000000000000',
                taxMethod: '',
                printTemplate: '',
                printSize: '',
                openingCash: '',
                expense: '',
                cashInHand: '',
                bank: '',
                show1: false,
                searchInvoice: '',
                focusValue: 'calculator',
                TouchInvoice: 'TouchInvoice',
                filePath: null,
                cashVoucherAllow: '',
                isDenomination: false,
                calculateValueShow: '',
                loginUserName: '',
                dayStartTime: '',
                counterCode: '',
                recieve: '',
                denominationSetuplist: [],
                isPay: false,
                isTouchScreen: false,
                companyId: '',
                invoiceWoInventory: '',
                styleclass: '',
                selectedValue: '',
                selectedProductValue: '',
                bankList: [],
                currencyList: [],
                autoNumber: '',
                autoNumberCredit: '',
                isAuthour: {
                    changePriceDuringSale: false,
                    giveDiscountDuringSale: false,
                    column: '',
                },
                changePriceDuringSale: false,
                giveDiscountDuringSale: false,
                show: false,
                isCardColor: false,
                walkcustomer: false,
                hold: false,
                unhold: false,
                authorize: {
                    column: '',
                    userName: '',
                    password: '',
                },
                wareHouserender: 0,
                itemRender: 0,
                isSaleReturn: false,
                search: '',
                currentPage: 1,
                pageCount: '',
                rowCount: '',

                categoryId: '00000000-0000-0000-0000-000000000000',
                products: [],
                produc: [],
                saleProducts: [],
                toggleCash: false,
                toggleCredit: true,
                quantityRander: 0,
                rander: 0,
                togglePayCash: 'Cash',
                toggleBank: 'Bank',
                togglePayVoucher: 'CashVoucher',
                toggleOtherCurrency: 'OtherCurrency',
                rendered: 0,
                sale: {
                    id: "00000000-0000-0000-0000-000000000000",
                    date: "",
                    taxMethod: "",
                    barCode: "",
                    dayStart: false,
                    counterId: '',
                    invoiceWoInventory: "",
                    registrationNo: "",
                    customerId: null,
                    dueDate: "",
                    wareHouseId: "",
                    refrenceNo: '',
                    saleItems: [],
                    isCredit: false,
                    cashCustomer: "Walk-In",
                    mobile: "",
                    email: "",
                    cashCustomerId: "",
                    code: "",
                    change: 0,
                    invoiceType: "",
                    voucherNo: '',
                    salePayment: {
                        dueAmount: 0,
                        received: 0,
                        balance: 0,
                        change: 0,
                        paymentTypes: [],
                        paymentType: '',
                        paymentOptionId: null,
                        paymentName: '',
                    },
                    otherCurrency: {
                        currencyId: null,
                        rate: 0,
                        amount: 0,
                    },

                    returnInvoiceAmount: 0,
                    isSaleReturnPost: false
                },
                printId: '00000000-0000-0000-0000-000000000000',
                printDetailsPos: [],
                printDetails: [],
                printDetailsCashVoucher: [],
                categorylist: [],
                printRender: 0,
                quantity: 0,
                loading: false,
                product: {
                    id: "",
                },
                vats: [],
                summary: {
                    item: 0,
                    qty: 0,
                    total: 0,
                    discount: 0,
                    withDisc: 0,
                    vat: 0,
                    withVat: 0,
                    bundleAmount: 0,
                    inclusiveVat: 0
                },
                headerFooter: {
                    returnDays: '',
                    footerEn: '',
                    footerAr: '',
                    printSizeA4: '',
                    company: ''
                },
                CompanyID: '',
                UserID: '',
                employeeId: '',
                isDayAlreadyStart: false,
                IsProduction: false,
                currency: '',
                calculator: false,
                bankId: null,
                otherCurrencyId: null,
                productList: [],
                isInvoiceSearch: false,
                returnItem: false,
                isReturnItem: false,
                postInvoiceDetail: '',
                isCashVoucher: false,
                saleList: [],
                saleId: '00000000-0000-0000-0000-000000000000',
                isDoublePrint: false,
                saleReturnRegNo: '',
                isOldInvoice: false,
                newProduct: {
                    id: '00000000-0000-0000-0000-000000000000',
                    englishName: '',
                    arabicName: '',
                    salePrice: 0,
                    isActive: true,
                    code: '',
                    taxMethod: '',
                    taxRateId: ''

                },
                showProduct: false,
                i: 1,
                numberKeyCalc: false,
                overWrite: false,
                BusinessLogo: '',
                BusinessNameArabic: '',
                BusinessNameEnglish: '',
                BusinessTypeArabic: '',
                BusinessTypeEnglish: '',
                CompanyNameArabic: '',
                CompanyNameEnglish: ''
            }
        },
        validations: {
            saleProducts: { required },
            sale: {
                date: { required },
                registrationNo: { required },
                customerId: {},
                wareHouseId: { required },
                cashCustomer: {
                    required: requiredIf((x) => {
                        if (x.customerId == '00000000-0000-0000-0000-000000000000' ||
                            x.customerId == null)
                            return true;
                        return false;
                    })
                },
            }
        },
        computed: {
            isPaymentValid: function () {



                var paymentTypesAmount;
                if (this.sale.salePayment.paymentTypes.length > 0) {
                    paymentTypesAmount = this.sale.salePayment.paymentTypes.reduce((total, payment) =>
                        total + payment.amount, 0);
                } else {
                    paymentTypesAmount = 0;
                }

                if (this.sale.salePayment.paymentType == "Bank") {
                    if (this.sale.salePayment.paymentOptionId == "00000000-0000-0000-0000-000000000000" ||
                        this.sale.salePayment.paymentOptionId == null) {
                        return false;
                    }
                }
                if (this.sale.salePayment.paymentType == "OtherCurrency") {
                    if (this.sale.otherCurrency.currencyId == "00000000-0000-0000-0000-000000000000" ||
                        this.sale.otherCurrency.currencyId == null) {
                        return false;
                    }
                }
                if ((parseFloat(this.sale.salePayment.received) <= parseFloat(this.sale.salePayment.dueAmount))) {
                    if (((parseFloat(this.sale.salePayment.received) + paymentTypesAmount)) >= this.sale.salePayment.dueAmount) {
                        return true
                    }
                } else {
                    if (((parseFloat(this.sale.salePayment.received) + paymentTypesAmount)) >= this.sale.salePayment.dueAmount) {
                        return true
                    }
                }
                return false;
            },
        },
        methods: {
            NumberKey(e) {

                if ((e.key >= 0 && e.key <= 9) || e.key === '.') {
                    //this.calculatorValuaCalculation(e.key.toString())
                    //var value = e.key;
                    var check = false
                    var total = 0
                    if (this.isDenomination === true) {
                        
                        if (this.recieve == '' || this.recieve == 0) {
                            this.calculateValueShow = e.key.toString()
                        }
                        else {
                            if (this.calculateValueShow[this.calculateValueShow.length - 1] == '+') {
                                this.calculateValueShow = this.calculateValueShow + e.key;
                            }
                            else {
                                this.calculateValueShow = this.calculateValueShow + '+' + e.key;
                            }
                        }
                        if (this.recieve == '') {
                            this.recieve == 0;
                            this.recieve = this.recieve + parseFloat(e.key);
                        }
                        else {
                            this.recieve = (parseFloat(this.recieve) + parseFloat(e.key)).toString();
                        }
                        const plus = "+";
                        check = this.calculateValueShow.includes(plus);
                        if (check) {
                            this.myResult = this.calculateValueShow.split("+");
                            total = this.myResult.reduce((total, prod) => total + parseFloat(prod), 0);

                            this.sale.salePayment.received = total;
                        }
                        else {

                            /*focus in otherCurrency input */
                            this.sale.salePayment.received = this.recieve;
                        }
                        if (this.isDenomination)
                            this.calculateValueShow = this.calculateValueShow.slice(0, -1)
                        this.isDenomination = false;
                        this.numberKeyCalc = true;


                    }
                    else {
                        
                        this.recieve = this.recieve + e.key
                        if (this.numberKeyCalc) {

                            this.calculateValueShow = this.calculateValueShow + e.key;

                        }
                        const plus = "+";
                        check = this.calculateValueShow.includes(plus);
                        if (check) {
                            this.myResult = this.calculateValueShow.split("+");
                            total = this.myResult.reduce((total, prod) => total + parseFloat(prod), 0);

                            this.sale.salePayment.received = total;
                        }
                        else {

                            /*focus in otherCurrency input */
                            this.sale.salePayment.received = this.recieve;
                        }

                        if (this.numberKeyCalc)
                            this.calculateValueShow = this.calculateValueShow.slice(0, -1)
                        //this.numberKeyCalc = false;
                        //this.sale.salePayment.received = this.recieve
                    }

                }
                else {
                    e.preventDefault()
                }
                this.barcode = '';
            },
            BackspaceKey(e) {
                
                if (e.key === 'Backspace') {

                    //var value = e.key;
                    this.recieve = this.recieve.slice(0, -1)
                    this.sale.salePayment.received = this.recieve
                }
                else if (e.key === 'Delete') {
                    this.recieve = '';
                    this.sale.salePayment.received = 0;
                    this.sale.otherCurrency.amount = 0;
                    this.sale.otherCurrency.rate = 0;
                    this.sale.voucherNo = '';
                    this.focusValue == 'calculator'
                    this.calculateValueShow = '';
                    this.isDenomination = false;
                }
                else {
                    e.preventDefault()
                }
                this.barcode = '';
            },
            onBarcodeScanned(barcode) {
                
                if (localStorage.getItem("BarcodeScan") != 'TouchScreenForBar')
                    return
                var root = this;
                var token = "";
                if (this.$session.exists()) {
                    token = localStorage.getItem("token");
                }

                var warehouseId = ''
                if (this.invoiceWoInventory == 'false')
                    warehouseId = this.sale.wareHouseId

                if (this.isInvoiceSearch == true) {
                    this.asyncFind(barcode);
                } else {

                    this.$https.get('/Product/GetProductInformationForTouch?categoryId=' + this.categoryId + '&searchTerm=' + barcode + '&wareHouseId=' + warehouseId, { headers: { "Authorization": `Bearer ${token}` } })

                        .then(function (response) {
                            if (response.data != null && response.data.results.products.length > 0) {
                                var product1 = [];
                                response.data.results.products.forEach(function (product) {
                                    product1.push({
                                        id: product.id,
                                        englishName: product.englishName != '' ? product.englishName : product.arabicName,
                                        arabicName: product.arabicName != '' ? product.arabicName : product.englishName,
                                        assortment: product.assortment,
                                        barCode: product.barCode,
                                        basicUnit: product.basicUnit,
                                        brandId: product.brandId,
                                        bundleCategory: product.bundleCategory,
                                        categoryId: product.categoryId,
                                        code: product.code,
                                        colorId: product.colorId,
                                        colorName: product.colorName,
                                        colorNameArabic: product.colorNameArabic,
                                        description: product.description,
                                        inventory: product.inventory,
                                        isActive: product.isActive,
                                        image: product.image,
                                        isExpire: product.isExpire,
                                        isRaw: product.isRaw,
                                        length: product.length,
                                        levelOneUnit: product.levelOneUnit,
                                        stockLevel: product.stockLevel,
                                        originId: product.originId,
                                        promotionOffer: product.promotionOffer,
                                        purchasePrice: product.purchasePrice,
                                        salePrice: product.salePrice,
                                        salePriceUnit: product.salePriceUnit,
                                        saleReturnDays: product.saleReturnDays,
                                        shelf: product.shelf,
                                        sizeId: product.sizeId,
                                        sizeName: product.sizeName,
                                        sizeNameArabic: product.sizeNameArabic,
                                        styleNumber: product.styleNumber,
                                        subCategoryId: product.subCategoryId,
                                        taxMethod: product.taxMethod,
                                        taxRate: product.taxRate,
                                        taxRateId: product.taxRateId,
                                        unit: product.unit,
                                        unitId: product.unitId,
                                        unitPerPack: product.unitPerPack,
                                        width: product.width,

                                    })
                                })

                                if (root.saleProducts.length > 0) {
                                    var existingProduct = root.saleProducts.find(x => x.productId == product1[0].id)
                                    if (existingProduct != null) {
                                        root.quantityIncrease(product1[0].id)
                                    }
                                    else {
                                        root.addProduct(product1[0].id, product1[0])
                                    }
                                } else {
                                    root.addProduct(product1[0].id, product1[0])
                                }
                                //root.addProduct(product1[0].id, product1[0])

                            }
                            else {
                                root.$swal({
                                    title: 'Error!',
                                    text: "Item not found",
                                    type: 'error',
                                    confirmButtonClass: "btn btn-danger",
                                    icon: 'error',
                                    timer: 1000,
                                    timerProgressBar: true,
                                });
                            }
                        });

                }



            },
            onCloseQuickProduct: function (product) {
                this.showProduct = false;
                this.barcode = ''
                this.addProduct(product[0].id, product[0])
            },
            addNewProduct: function () {
                this.newProduct = {
                    id: '00000000-0000-0000-0000-000000000000',
                    englishName: '',
                    arabicName: '',
                    salePrice: 0,
                    isActive: true,
                    code: '',
                    taxMethod: '',
                    unitId: '',
                    levelOneUnit: '',
                    taxRateId: '',
                    barcode: '',
                    categoryId: '',



                }
                this.showProduct = !this.showProduct;
                this.type = "Add";
            },
            DayEnd: function () {
                var root = this;
                var userID = localStorage.getItem('UserID');
                var supervisorLogin = localStorage.getItem('IsSupervisor') == 'true' ? true : false;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('/Product/IsDayStart?userId=' + userID + '&employeeId' + this.employeeId + '&isSupervisor=' + supervisorLogin, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data.isDayStart) {
                            root.dayStartId = response.data.dayStartId;
                            root.isFirstUser = response.data.isFirstUser;
                            root.cashInHand = response.data.cashInHand;
                            //root.counterId = response.data.counterId;
                            root.bank = response.data.bank;
                            root.openingCash = response.data.openingCash;
                            root.show1 = !root.show1;
                            root.type = "Add";

                        } else {
                            console.log(response.date);
                        }
                    },
                        function (error) {
                            root.loading = false;
                            console.log(error);
                        });
            },
            Reset: function (value) {
                this.sale.cashCustomer = "Walk-In";
                this.isInvoiceSearch = false;
                this.productOption = [];
                this.searchInvoice = '';
                this.counterRequest = 1;
                //this.denominationSetuplist = [];
                //this.isPay = false;
                this.isTouchScreen = false;
                this.styleclass = '';
                this.currencyList = [];
                this.show = false;
                this.wareHouserender = 0;
                this.itemRender = 0;
                this.search = '';

                this.categoryId = '';
                this.products = [];
                this.saleProducts = [];
                this.toggleCash = false;
                this.toggleCredit = true;
                this.quantityRander = 0;
                this.rander = 0;
                this.togglePayCash = 'Cash';
                this.toggleBank = 'Bank';
                this.togglePayVoucher = 'CashVoucher';
                this.toggleOtherCurrency = 'OtherCurrency';
                this.rendered = 0;

                this.printId = '00000000-0000-0000-0000-000000000000';
                this.printDetailsPos = [];
                this.printDetails = [];
                this.printDetailsCashVoucher = [];
                this.printRender = 0;
                this.quantity = 0;

                this.sale.salePayment.paymentTypes = [];
                this.sale.salePayment.balance = 0;
                this.sale.salePayment.dueAmount = 0;
                this.sale.salePayment.received = 0;
                this.sale.salePayment.change = 0;
                this.sale.salePayment.paymentType = '';
                this.sale.salePayment.paymentName = '';
                this.calculatorValuaCalculation('c');
                this.calculatBalance(0);

                this.product = {
                    id: "",
                };
                this.summary = {
                    item: 0,
                    qty: 0,
                    total: 0,
                    discount: 0,
                    withDisc: 0,
                    vat: 0,
                    withVat: 0,
                    bundleAmount: 0,
                    inclusiveVat: 0
                };

                this.bankId = null;
                this.otherCurrencyId = null;
                this.postInvoiceDetail = '';
                this.saleList = [];
                this.saleId = '00000000-0000-0000-0000-000000000000';
                this.sale.id = '00000000-0000-0000-0000-000000000000';
                this.saleReturnRegNo = '';
                this.HidePayment();
                if (value) {
                    this.produc = [];
                    this.AutoIncrementCode();
                }
                console.log("resset")
            },

            ResetProductFilter: function () {
                this.categoryId = ''
                this.search = ''
                this.getProduct();
            },

            onBarcodeScannedInvoice: function () {
                if (this.i == 6) {
                    console.log(this.searchBarcode + this.i);
                    this.onBarcodeScannedBySearch(this.searchBarcode)
                }
                this.i++
            },
            getDate: function (date) {
                return moment(date).format('LLL');
            },
            FocusInput: function (prop, event) {

                if (prop == 'amount') {
                    this.focusValue = prop;
                    console.log(event.target.select());
                }
                if (prop == 'rate') {
                    this.focusValue = prop;
                    console.log(event.target.select());
                }
                if (prop == 'voucher') {
                    this.focusValue = prop;
                    console.log(event.target.select());
                }
                this.calculator = true;
            },
            FocusOutInput: function () {
                //
                //this.focusValue = 'calculator';
                console.log(this.focusValue);
            },
            OtherCurrencyCalculate: function () {
                this.sale.salePayment.received = parseFloat(this.sale.otherCurrency.amount == '' ? 0 : this.sale.otherCurrency.amount).toFixed(3).slice(0, -1) * parseFloat(this.sale.otherCurrency.rate == '' ? 0 : this.sale.otherCurrency.rate).toFixed(3).slice(0, -1);
            },
            VerifyCashVoucher: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.$https.get('/Sale/VerifyCashVouch?voucherNo=' + this.sale.voucherNo, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null) {

                            var voucherDetail = response.data;
                            if (root.sale.salePayment.paymentTypes.filter(x => x.paymentType == 'CashVoucher').length == 0) {
                                root.sale.salePayment.paymentOptionId = response.data.id;
                                root.addPayment(voucherDetail.amount, 'CashVoucher', 'CashVoucher');

                            }
                        }
                    }).catch(error => {

                        root.$swal.fire(
                            {
                                icon: 'error',
                                title: 'Error!',
                                text: error.response.data,
                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });

                    });
            },

            asyncFind: function (search) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                if (search != '') {
                    this.isLoading = true;
                    this.$https.get('/Sale/SaleList?searchTerm=' + search + '&isDropdown=true', { headers: { "Authorization": `Bearer ${token}` } })
                        .then(function (response) {
                            if (response.data != null) {
                                root.saleList = [];
                                response.data.results.forEach(function (result) {
                                    
                                    root.saleList.push({
                                        id: result.id,
                                        name: result.registrationNumber + ' ' + (result.customerName != '' && result.customerName != null ? result.customerName : result.customerNameArabic),
                                    });
                                });
                                root.isLoading = false;
                            }
                        }).catch(error => {
                            root.isLoading = false;
                            root.$swal.fire(
                                {
                                    icon: 'error',
                                    title: 'Error!',
                                    text: error.response.data,
                                    showConfirmButton: false,
                                    timer: 5000,
                                    timerProgressBar: true,
                                });

                        });

                }
                root.barcode = ''

            },
            getPostInvoiceDetail: function (id) {
                
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                this.$https.get('/Sale/SaleDetail?id=' + id, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null) {
                            root.postInvoiceDetail = response.data;
                            root.postInvoiceDetail.date = moment(root.postInvoiceDetail.date).format("LLL");
                            root.isCashVoucher = true;
                            root.openReturnItemModel();
                        }
                        else {
                            root.$swal({
                                title: 'Error!',
                                text: response.data,
                                type: 'error',
                                confirmButtonClass: "btn btn-danger",
                                icon: 'error',
                                timer: 1500,
                                timerProgressBar: true,
                            });
                        }
                    }).catch(error => {
                        root.$swal.fire(
                            {
                                icon: 'error',
                                title: 'Error!',
                                text: error.response.data,
                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });
                    });
                root.barcode = ''

            },

            serachInvoiceByBarcode: function (value) {

                this.isInvoiceSearch = value;
                this.selectedProductValue = '';
                this.selectedValue = '';
                if (!value) {
                    this.search = '';
                }
                else {
                    this.postInvoiceDetail = '';
                    this.saleList = [];
                }
            },
            GetProductList: function () {
                var root = this;
                var token = "";
                if (this.$session.exists()) {
                    token = localStorage.getItem("token");
                }

                this.isRaw = this.raw == undefined ? false : this.raw;
                //search = search == undefined ? '' : search;
                // var url = this.wareHouseId != undefined ? "/Product/GetProductInformation?searchTerm=" + search + '&wareHouseId=' + this.wareHouseId + "&isDropdown=true" + '&isRaw=' + root.isRaw : "/Product/GetProductInformation?searchTerm=" + search + '&status=' + root.status + "&isDropdown=true" + '&isRaw=' + root.isRaw;

                this.$https
                    .get("/Product/GetProductBarcode?isRaw=" + root.isRaw + '&wareHouseId=' + this.sale.wareHouseId, {
                        headers: { Authorization: `Bearer ${token}` },
                    })
                    .then(function (response) {

                        if (response.data != null) {
                            root.productList = response.data.results.products;

                        }
                    });


            },
            onBarcodeScannedBySearch(barcode) {

                var root = this;
                var token = "";
                if (this.$session.exists()) {
                    token = localStorage.getItem("token");
                }

                var warehouseId = ''
                if (this.invoiceWoInventory == 'false')
                    warehouseId = this.sale.wareHouseId

                if (this.isInvoiceSearch == true) {
                    this.getInvoiceList(barcode);
                    root.searchBarcode = ''
                    root.i = 0
                } else {

                    this.$https.get('/Product/GetProductInformationForTouch?categoryId=' + this.categoryId + '&searchTerm=' + barcode + '&wareHouseId=' + warehouseId, { headers: { "Authorization": `Bearer ${token}` } })

                        .then(function (response) {
                            if (response.data != null) {
                                console.log("msg is:" + root.searchBarcode)
                                var product = response.data.results.products.find(x => x.barCode == root.searchBarcode)
                                console.log(product.englishName)
                                var product1 = {};
                                product1.id = product.id;
                                product1.englishName = product.englishName != '' ? product.englishName : product.arabicName;
                                product1.arabicName = product.arabicName != '' ? product.arabicName : product.englishName;
                                product1.assortment = product.assortment;
                                product1.barCode = product.barCode;
                                product1.basicUnit = product.basicUnit;
                                product1.brandId = product.brandId;
                                product1.bundleCategory = product.bundleCategory;
                                product1.categoryId = product.categoryId;
                                product1.code = product.code;
                                product1.colorId = product.colorId;
                                product1.colorName = product.colorName;
                                product1.colorNameArabic = product.colorNameArabic;
                                product1.description = product.description;
                                product1.inventory = product.inventory;
                                product1.isActive = product.isActive;
                                product1.image = product.image;
                                product1.isExpire = product.isExpire;
                                product1.isRaw = product.isRaw;
                                product1.length = product.length;
                                product1.levelOneUnit = product.levelOneUnit;
                                product1.stockLevel = product.stockLevel;
                                product1.originId = product.originId;
                                product1.promotionOffer = product.promotionOffer;
                                product1.purchasePrice = product.purchasePrice;
                                product1.salePrice = product.salePrice;
                                product1.salePriceUnit = product.salePriceUnit;
                                product1.saleReturnDays = product.saleReturnDays;
                                product1.shelf = product.shelf;
                                product1.sizeId = product.sizeId;
                                product1.sizeName = product.sizeName;
                                product1.sizeNameArabic = product.sizeNameArabic;
                                product1.styleNumber = product.styleNumber;
                                product1.subCategoryId = product.subCategoryId;
                                product1.taxMethod = product.taxMethod;
                                product1.taxRate = product.taxRate;
                                product1.taxRateId = product.taxRateId;
                                product1.unit = product.unit;
                                product1.unitId = product.unitId;
                                product1.unitPerPack = product.unitPerPack;
                                product1.width = product.width;

                                if (root.saleProducts.length > 0) {
                                    var existingProduct = root.saleProducts.find(x => x.productId == product1.id)
                                    if (existingProduct != null) {
                                        root.quantityIncrease(product1.id)
                                    }
                                    else {
                                        root.addProduct(product1.id, product1)
                                    }
                                } else {
                                    root.addProduct(product1.id, product1)
                                }
                                root.addProduct(product1.id, product1)

                            }
                            else {
                                root.$swal.fire(
                                    {
                                        icon: 'error',
                                        title: 'Item not found',
                                        text: "Item not found in this scanned barcode",
                                        showConfirmButton: false,
                                        timer: 5000,
                                        timerProgressBar: true,
                                    });
                            }
                            root.searchBarcode = ''
                            root.i = 0
                        }).catch(error => {
                            console.log(error)
                            root.$swal.fire(
                                {
                                    icon: 'error',
                                    title: 'Something Went Wrong!',
                                    text: error.response.data,
                                    showConfirmButton: false,
                                    timer: 5000,
                                    timerProgressBar: true,
                                });

                            root.loading = false
                            root.searchBarcode = ''
                            root.i = 0
                        })
                        .finally(() => {
                            root.loading = false;
                            root.searchBarcode = ''
                            root.i = 0
                        })

                }



            },
            GetDenominationSetupData: function () {
                var root = this;
                var url = '/Product/DenominationSetupList';
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get(url, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.denominationSetuplist = response.data.denominationSetups;

                    }
                });
            },
            calculatorValuaCalculation: function (value, type) {
                var check = false;

                
                if (this.focusValue == 'amount' && value != 'c') {
                    if (value == 'back') {
                        if (this.sale.otherCurrency.amount != '' && this.sale.otherCurrency.amount != 0) {
                            this.sale.otherCurrency.amount = this.sale.otherCurrency.amount.slice(0, -1);
                        }
                    }
                    else {
                        if (this.sale.otherCurrency.amount == 0) {
                            this.sale.otherCurrency.amount = value;
                        }
                        else {
                            this.sale.otherCurrency.amount = this.sale.otherCurrency.amount + value;
                        }
                    }
                    this.OtherCurrencyCalculate();
                }
                else if (this.focusValue == 'rate' && value != 'c') {
                    if (value == 'back') {
                        if (this.sale.otherCurrency.rate != '' && this.sale.otherCurrency.rate != 0) {
                            this.sale.otherCurrency.rate = this.sale.otherCurrency.rate.slice(0, -1);
                        }
                    }
                    else {
                        if (this.sale.otherCurrency.rate == 0) {
                            this.sale.otherCurrency.rate = value;
                        }
                        else {
                            this.sale.otherCurrency.rate = this.sale.otherCurrency.rate + value;
                        }
                    }
                    this.OtherCurrencyCalculate();
                }
                else if (this.focusValue == 'voucher' && value != 'c') {
                    if (value == 'back') {
                        if (this.sale.voucherNo != '') {
                            this.sale.voucherNo = this.sale.voucherNo.slice(0, -1);
                        }
                    }
                    else {
                        this.sale.voucherNo = this.sale.voucherNo + value;
                    }
                }
                else {
                    var total = 0;
                    if (type == 'denomination') {

                        this.isDenomination = true;
                        if (this.recieve == '' || this.recieve == 0) {
                            this.calculateValueShow = value.toString()
                        }
                        else {
                            if (this.calculateValueShow[this.calculateValueShow.length - 1] == '+') {
                                this.calculateValueShow = this.calculateValueShow + value;
                            }
                            else {
                                this.calculateValueShow = this.calculateValueShow + '+' + value;
                            }
                        }

                        if (this.recieve == '') {
                            this.recieve == 0;
                            this.recieve = this.recieve + value;
                        }
                        else {
                            this.recieve = (parseFloat(this.recieve) + value).toString();
                        }
                        const plus = "+";
                        check = this.calculateValueShow.includes(plus);
                        if (check) {
                            this.myResult = this.calculateValueShow.split("+");
                            total = this.myResult.reduce((total, prod) => total + parseFloat(prod), 0);

                            this.sale.salePayment.received = total;
                        }
                        else {

                            /*focus in otherCurrency input */
                            this.sale.salePayment.received = this.recieve;
                        }
                    }
                    else {
                        if (value == 'c') {
                            this.recieve = '';
                            this.sale.salePayment.received = 0;
                            this.sale.otherCurrency.amount = 0;
                            this.sale.otherCurrency.rate = 0;
                            this.sale.voucherNo = '';
                            this.focusValue == 'calculator'
                            this.calculateValueShow = '';
                            this.isDenomination = false;
                        }
                        else if (value == 'back') {

                            this.calculateValueShow = this.calculateValueShow.slice(0, -1);
                            if (this.calculateValueShow == "") {
                                this.recieve = '';
                                this.sale.salePayment.received = 0;
                                this.isDenomination = false;
                            }
                            else {
                                var plus = "+";
                                check = this.calculateValueShow.includes(plus);
                                if (check) {
                                    var lastDig = this.calculateValueShow[this.calculateValueShow.length - 1];
                                    console.log(lastDig);
                                    if (lastDig == '+') {
                                        var calculateValueShowNew = this.calculateValueShow.slice(0, -1);
                                        this.myResult = calculateValueShowNew.split("+");
                                        total = this.myResult.reduce((total, prod) =>
                                            total + parseFloat(prod), 0);

                                        this.sale.salePayment.received = total;
                                    }
                                    else {
                                        this.myResult = this.calculateValueShow.split("+");
                                        total = this.myResult.reduce((total, prod) =>
                                            total + parseFloat(prod), 0);

                                        this.sale.salePayment.received = total;
                                    }

                                }
                                else {
                                    this.sale.salePayment.received = this.calculateValueShow;

                                    this.recieve = this.calculateValueShow;
                                }
                            }
                        }
                        else {

                            if (this.recieve == '') {
                                this.recieve = this.recieve + value;
                                //var lDig = this.calculateValueShow[this.calculateValueShow.length - 1];
                                if (this.calculateValueShow[this.calculateValueShow.length - 1] == '+') {
                                    this.calculateValueShow = this.isDenomination ? this.calculateValueShow + (value == '.' ? '0.' : value) : this.calculateValueShow + ((this.recieve == '.' && value == '.') ? '0.' : value);

                                }
                                else {
                                    this.calculateValueShow = this.isDenomination ? this.calculateValueShow + '+' + (value == '.' ? '0.' : value) : this.calculateValueShow + ((this.recieve == '.' && value == '.') ? '0.' : value);

                                }
                                const plus1 = "+";
                                check = this.calculateValueShow.includes(plus1);
                                if (check) {
                                    this.myResult = this.calculateValueShow.split("+");
                                    total = this.myResult.reduce((total, prod) =>
                                        total + parseFloat(prod), 0);

                                    this.sale.salePayment.received = total;
                                }
                                else {

                                    this.sale.salePayment.received = this.recieve;
                                }
                                this.isDenomination = false;
                            }
                            else {
                                var lastDigit = this.recieve.slice(-1);

                                if (lastDigit == '.' && value == '.') {
                                    console.log(lastDigit);
                                }
                                else {

                                    var lastResult = this.calculateValueShow.split("+");
                                    var val = lastResult[lastResult.length - 1];
                                    const dot = ".";
                                    var checkDot = val.includes(dot);

                                    if (checkDot && value == '.') {
                                        console.log('Cannot Repeat Dot');
                                    }
                                    else {
                                        this.recieve = this.recieve + value;
                                        //var lastDig = this.calculateValueShow[this.calculateValueShow.length - 1];
                                        if (this.calculateValueShow[this.calculateValueShow.length - 1] == '+') {
                                            this.calculateValueShow = this.isDenomination ? this.calculateValueShow + (value == '.' ? '0.' : value) : this.calculateValueShow + ((this.recieve == '.' && value == '.') ? '0.' : value);
                                        }
                                        else {
                                            this.calculateValueShow = this.isDenomination ? this.calculateValueShow + '+' + (value == '.' ? '0.' : value) : this.calculateValueShow + ((this.recieve == '.' && value == '.') ? '0.' : value);
                                        }
                                        const plus1 = "+";
                                        check = this.calculateValueShow.includes(plus1);
                                        if (check) {
                                            this.myResult = this.calculateValueShow.split("+");
                                            total = this.myResult.reduce((total, prod) =>
                                                total + parseFloat(prod), 0);


                                            this.sale.salePayment.received = total;
                                        }
                                        else {

                                            this.sale.salePayment.received = this.recieve;
                                        }
                                        this.isDenomination = false;
                                    }
                                }
                            }

                        }
                    }
                }

            },
            calculatorPanelOpen: function (value) {
                this.calculator = value;
                this.focusValue = 'calculator';
            },

            select: function () {
                this.$refs.input.select();
            },

            //Reset: function () {
            //    this.$router.go();
            //},

            EditTOuchInvocie: function (data) {

                var root = this;

                this.saleReturnRegNo = data.registrationNo;
                this.sale.isSaleReturnPost = true;
                this.isOldInvoice = true;
                this.saleProducts = [];
                {
                    if (data.isReturnItem) {
                        this.sale.id = '00000000-0000-0000-0000-000000000000';
                    }
                    else {
                        this.sale.id = data.id;
                        this.sale.registrationNo = data.registrationNo;
                    }
                    this.sale.invoiceType = data.invoiceType;
                    this.sale.cashCustomer = data.cashCustomer;
                    this.sale.dueDate = moment(data.dueDate).format("LLL");
                    this.sale.refrenceNo = data.refrenceNo;
                    this.sale.mobile = data.mobile;
                    this.sale.code = data.code;
                    this.sale.customerId = data.customerId;
                    this.sale.saleItems = data.saleItems;
                    this.sale.wareHouseId = data.wareHouseId;
                    this.sale.cashCustomerId = data.cashCustomerId;
                    this.sale.email = data.email;
                    this.sale.saleInvoiceId = data.id;
                    this.sale.isReturnItem = data.isReturnItem;
                    this.sale.salePayment = {
                        dueAmount: 0,
                        received: 0,
                        balance: 0,
                        change: 0,
                        paymentTypes: [],
                        paymentType: 'Cash',
                        paymentOptionId: '',
                        paymentName: 'Cash',
                    };
                }
                this.getData();
                if (this.$route.query.mobiledata != undefined) {
                    for (var j = 0; j < this.$route.query.mobiledata.mobileOrderItemLookupModels.length; j++) {
                        this.saleProducts.quantity[j] = this.$route.query.mobiledata.mobileOrderItemLookupModels[j].quantity[j];
                    }
                    root.calcuateSummary();
                    this.saleProducts.rowId = this.$route.query.mobiledata.mobileOrderItemLookupModels.rowId;
                    this.saleProducts.quantity = this.$route.query.mobiledata.mobileOrderItemLookupModels.quantity;
                }
                this.itemRender++;
            },
            quantityIncrease: function (productId) {

                if (this.saleProducts.some(x => x.productId == productId)) {
                    var prd = this.saleProducts.find(x => x.productId == productId);
                    if (prd.quantity < 0) {
                        prd.quantity--;
                    }
                    else {
                        prd.quantity++;
                    }
                    this.updateLineTotal(prd.quantity, "quantity", prd);
                }
            },
            quantityDecrease: function (productId) {

                if (this.saleProducts.some(x => x.productId == productId)) {
                    var prd = this.saleProducts.find(x => x.productId == productId);
                    if (prd.quantity < 0) {
                        prd.quantity++;
                    }
                    else {
                        prd.quantity--;
                    }
                    this.updateLineTotal(prd.quantity, "quantity", prd);
                }
            },
            WalkIn: function (x) {


                if (x == false) {
                    this.show = false;
                    this.walkcustomer = false;
                }
                else {
                    this.sale.cashCustomer = x.cashCustomer;
                    this.sale.mobile = x.mobile;
                    this.sale.customerId = x.customerId;
                    this.show = false;
                    this.walkcustomer = false;
                }
                this.barcode = '';
            },

            openWalkModel: function () {
                this.newsale = this.sale;

                this.walkcustomer = !this.walkcustomer;
            },
            holdCustomer: function (x) {

                if (x == false) {
                    this.show = false;
                    this.hold = false;
                }
                else {
                    this.sale.refrenceNo = x.refrenceNo;
                    this.show = false;
                    this.hold = false;
                }
                this.barcode = '';
            },

            openHoldModel: function () {
                this.newsale = {
                    id: "00000000-0000-0000-0000-000000000000",
                    refrenceNo: this.sale.refrenceNo,
                    invoiceType: 'Hold',


                },
                    this.hold = !this.hold;
            },
            UnholdCustomer: function (x) {

                if (x == false) {
                    this.show = false;
                    this.unhold = false;
                }
                else {
                    this.sale.refrenceNo = x.refrenceNo;
                    this.show = false;
                    this.unhold = false;
                }
                this.barcode = '';
            },
            returnItemModelClose: function (x) {

                if (x == false) {
                    this.show = false;
                    this.returnItem = false;
                }
                else {
                    this.show = false;
                    this.returnItem = false;
                }
                this.barcode = '';
            },
            openUnHoldModel: function () {
                this.newsale = {
                    id: "00000000-0000-0000-0000-000000000000",
                }
                this.unhold = !this.unhold;
            },
            openReturnItemModel: function () {

                if (this.headerFooter.returnDays == 'null') {
                    if (this.postInvoiceDetail != '' && this.postInvoiceDetail != undefined && this.postInvoiceDetail != null) {
                        this.returnItem = !this.returnItem;
                    }
                }
                else {
                    var invoiceDate = moment(this.postInvoiceDetail.date).add(this.headerFooter.returnDays, 'days').format("LLL");
                    var todayDate = moment().format("LLL");
                    var isTrue = moment(invoiceDate).isSameOrAfter(todayDate);
                    if (isTrue) {
                        if (this.postInvoiceDetail != '' && this.postInvoiceDetail != undefined && this.postInvoiceDetail != null) {
                            this.returnItem = !this.returnItem;
                        }
                    }
                    else {
                        this.$swal({
                            title: 'Error!',
                            text: this.postInvoiceDetail.registrationNo + ' is Expired',
                            type: 'error',
                            confirmButtonClass: "btn btn-danger",
                            icon: 'error',
                            timer: 1500,
                            timerProgressBar: true,
                        });
                    }
                }
            },
            GetCategoryData: function (search, isActive) {
                var root = this;

                var url = '/Product/GetCategoryInformation?isActive=' + isActive + '&isTouch=true' + '&searchTerm=' + search;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get(url, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.categorylist = [];
                        response.data.results.categories.forEach(function (cat) {
                            root.categorylist.push({
                                id: cat.id,
                                name: (root.$i18n.locale == 'en' || root.isLeftToRight()) ? (cat.name != '' ? cat.name : cat.nameArabic) : (cat.nameArabic != '' ? cat.nameArabic : cat.name)
                            })
                        })
                        root.pageCount = response.data.pageCount;
                        root.rowCount = response.data.rowCount;
                    }
                });

            },
            result: function (x) {
                this.isAuthour = x;
            },
            openmodel: function (column) {

                this.authorize = {
                    userName: '',
                    password: '',
                    column: column
                }
                this.show = !this.show;
            },
            openmodel1: function (column) {

                this.authorize = {
                    userName: '',
                    password: '',
                    column: column
                }
                this.show = !this.show;
            },
            openmodel2: function (column) {

                this.authorize = {
                    userName: '',
                    password: '',
                    column: column
                }
                this.show = !this.show;
            },

            getProduct: function (search) {

                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                if (search != '') {
                    this.isLoading = true;
                    if (this.invoiceWoInventory == 'false') {
                        this.$https.get('/Product/GetProductInformationForTouch?searchTerm=' + search + '&wareHouseId=' + this.sale.wareHouseId, { headers: { "Authorization": `Bearer ${token}` } })
                            .then(function (response) {
                                if (response.data != null) {
                                    root.produc = [];
                                    root.productOption = [];
                                    root.produc = response.data.results.products;

                                    response.data.results.products.forEach(function (prod) {
                                        root.productOption.push({
                                            id: prod.id,
                                            name: (root.$i18n.locale == 'en' || root.isLeftToRight()) ? prod.code + ' ' + (prod.englishName != '' ? prod.englishName : prod.arabicName) : prod.code + ' ' + (prod.englishName != '' ? prod.englishName : prod.arabicName),
                                        })
                                    })
                                    root.isLoading = false;
                                }
                            }).catch(error => {
                                root.isLoading = false;
                                root.$swal.fire(
                                    {
                                        icon: 'error',
                                        title: 'Error!',
                                        text: error.response.data,
                                        showConfirmButton: true,

                                    });

                            });
                    }
                    else {
                        this.$https.get('/Product/GetProductInformationForTouch?searchTerm=' + search, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                            if (response.data != null) {
                                root.produc = [];
                                root.productOption = [];
                                root.produc = response.data.results.products;
                                response.data.results.products.forEach(function (prod) {
                                    root.productOption.push({
                                        id: prod.id,
                                        name: (root.$i18n.locale == 'en' || root.isLeftToRight()) ? prod.code + ' ' + (prod.englishName != '' ? prod.englishName : prod.arabicName) : prod.code + ' ' + (prod.englishName != '' ? prod.englishName : prod.arabicName),
                                    })
                                })
                                root.isLoading = false;
                            }
                        })
                    }
                }
                root.barcode = ''

            },
            getBank: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                this.$https.get('/Product/PaymentOptionsList?isActive=true', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.bankList = response.data.paymentOptions;
                    }
                })
            },

            getCurrency: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                this.$https.get('/Product/CurrencyList', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.currencyList = response.data.currencies;
                        root.currencyList.splice(0, 1);
                    }
                })
            },

            changeProduct: function (NewProdId, rowId) {
                this.saleProducts = this.saleProducts.filter(x => x.rowId != rowId);
                this.addProduct(NewProdId);

            },

            getVatValue: function (id, prod) {
                var vat = this.vats.find((value) => value.id == id);
                prod.taxRateId = id;
                prod.rate = vat.rate;
                this.updateLineTotal(prod.unitPrice, "unitPrice", prod);
                return vat.rate;
            },
            removeProduct: function (id) {
                this.saleProducts = this.saleProducts.filter((prod) => {
                    return prod.rowId != id;
                });

                this.calcuateSummary();
            },

            getData: function () {
                var root = this;


                var token = "";
                if (this.$session.exists()) {
                    token = localStorage.getItem("token");
                }
                root.$https
                    .get("/Product/TaxRateList", {
                        headers: { Authorization: `Bearer ${token}` },
                    })
                    .then(function (response) {
                        if (response.data != null) {
                            root.vats = response.data.taxRates;
                        }
                    }).then(function () {
                        if (root.sale.saleItems != undefined) {

                            root.sale.saleItems.forEach(function (item) {
                                var vat = root.vats.find((value) => value.id == item.taxRateId);
                                if (root.sale.isReturnItem) {
                                    //if (item.returnQuantity != 0 && item.returnQuantity != '' && item.returnQuantity != undefined && item.returnQuantity <= item.quantity)
                                    //{
                                    root.products.push(item.product);

                                    root.saleProducts.push({
                                        rowId: item.id,
                                        productName: item.productName,
                                        code: item.code,
                                        productId: item.productId,
                                        unitPrice: item.unitPrice == 0 ? '0' : item.unitPrice,
                                        quantity: item.returnQuantity,
                                        returnQuantity: item.returnQuantity == '' || item.returnQuantity == undefined ? 0 : item.returnQuantity,
                                        discount: item.discount,
                                        fixDiscount: item.fixDiscount,
                                        taxRateId: item.taxRateId,
                                        taxMethod: item.taxMethod,
                                        rate: vat.rate,
                                        saleReturnDays: item.saleReturnDays,
                                        lineTotal: item.unitPrice * item.quantity,
                                    });

                                    var product1 = root.saleProducts.find((x) => {
                                        return x.productId == item.productId;
                                    });
                                    root.getVatValue(product1.taxRateId, product1);
                                    root.updateLineTotal(item.returnQuantity, "quantity", product1);
                                    root.product.id = "";
                                    root.rendered++;
                                    /*}*/

                                }
                                else {
                                    root.products.push(item.product);

                                    root.saleProducts.push({
                                        rowId: item.id,
                                        productName: item.productName,
                                        code: item.code,
                                        productId: item.productId,
                                        unitPrice: item.unitPrice == 0 ? '0' : item.unitPrice,
                                        quantity: item.quantity,
                                        returnQuantity: item.returnQuantity == '' || item.returnQuantity == undefined ? 0 : item.returnQuantity,
                                        discount: item.discount,
                                        fixDiscount: item.fixDiscount,
                                        taxRateId: item.taxRateId,
                                        taxMethod: item.taxMethod,
                                        rate: vat.rate,
                                        saleReturnDays: item.saleReturnDays,
                                        lineTotal: item.unitPrice * item.quantity,
                                    });

                                    var product = root.saleProducts.find((x) => {
                                        return x.productId == item.productId;
                                    });
                                    root.getVatValue(product.taxRateId, product);
                                    root.updateLineTotal(item.quantity, "quantity", product);
                                    root.product.id = "";
                                    root.rendered++;
                                }

                            });
                            root.$emit("details", root.saleProducts);
                        }
                    });
            },
            selectCurrency: function (id, name) {
                this.bankId = null;
                this.otherCurrencyId = id;
                this.isActive = true;
                this.sale.salePayment.paymentName = name;
                this.sale.otherCurrency.currencyId = id;
            },

            selectBank: function (id, name) {
                this.otherCurrencyId = null;
                this.bankId = id;
                this.isActive = true;
                this.sale.salePayment.paymentOptionId = id;
                this.sale.salePayment.paymentName = name;
            },

            isPayment: function (credit) {
                
                this.$nextTick(() => {
                    let input = this.$refs.calInput;
                    input.focus();
                });

                this.otherCurrencyId = null;
                this.bankId = null;
                if (credit == 'Cash') {
                    this.sale.salePayment.paymentName = 'Cash';
                }
                this.sale.salePayment.paymentType = credit;
                this.focusValue = 'calculator';
            },
            isCredit: function (credit) {

                this.sale.isCredit = credit;
                if (!this.sale.isCredit) {
                    this.sale.customerId = null;
                }

            },

            emptyCashCustomer: function (customerId) {
                this.sale.customerId = customerId;
                if (this.sale.customerId != '00000000-0000-0000-0000-000000000000' && this.sale.customerId != null) {
                    this.sale.cashCustomer = "Walk-In";
                    this.sale.mobile = "";
                }
            },

            setCustomer: function (value) {
                console.log(value);
            },

            calculatBalance: function (received) {
                

                if (received == '') {
                    received = 0;
                }
                var paymentTypesAmount;
                if (this.sale.salePayment.paymentTypes.length > 0) {
                    paymentTypesAmount = this.sale.salePayment.paymentTypes.reduce((total, payment) =>
                        total + payment.amount, 0);
                } else {
                    paymentTypesAmount = 0;
                }

                this.sale.salePayment.balance = ((parseFloat(received) + paymentTypesAmount) - this.sale.salePayment.dueAmount <= 0 ? (parseFloat(received) + paymentTypesAmount) - this.sale.salePayment.dueAmount : 0).toFixed(3).slice(0, -1);
                this.sale.salePayment.change = ((parseFloat(received) + paymentTypesAmount) - this.sale.salePayment.dueAmount > 0 ? (parseFloat(received) + paymentTypesAmount) - this.sale.salePayment.dueAmount : 0).toFixed(3).slice(0, -1);
                this.sale.change = this.sale.salePayment.change;
            },

            addPayment: function (amount, paymentType, name) {
                var root = this;
                this.sale.salePayment.received = 0;
                this.calculateValueShow = '';
                this.isDenomination = false;
                this.recieve = '';

                if (paymentType == 'Cash') {
                    var payment = this.sale.salePayment.paymentTypes.find((x) => x.paymentType == paymentType)
                    if (payment != undefined) {
                        payment.amount += parseFloat(amount);
                        payment.name = name;
                    }
                    else {
                        this.sale.salePayment.paymentTypes.push({ paymentType: paymentType, amount: parseFloat(amount), name: name, rate: 0, otherAmount: 0 });
                    }
                }
                else if (paymentType == 'Bank') {
                    this.sale.salePayment.paymentTypes.push({ paymentType: paymentType, amount: parseFloat(amount), name: name, rate: 0, otherAmount: 0 });
                }
                else if (paymentType == 'CashVoucher') {
                    this.sale.salePayment.paymentTypes.push({ paymentType: paymentType, amount: parseFloat(amount), name: name, rate: 0, otherAmount: 0 });
                }
                else {
                    this.sale.salePayment.paymentTypes.push({ paymentType: paymentType, amount: parseFloat(amount), name: name, rate: root.sale.otherCurrency.rate, otherAmount: root.sale.otherCurrency.amount });
                }

                this.calculatBalance(0);
                this.sale.otherCurrency.amount = 0;
                this.sale.otherCurrency.rate = 0;
                //this.calculatorPanelOpen(false);

            },

            removeFromPaymentList: function (paymentType) {

                this.sale.salePayment.paymentTypes.splice(paymentType, 1);
                this.calculatBalance(0);
            },
            HidePayment: function () {


                this.isPay = false;
                this.calculator = false;
            },
            updateSummary: function () {

                //this.isPay = true;
                this.sale.salePayment.dueAmount = parseFloat(this.summary.withVat);
                this.sale.salePayment.received = 0;
                this.sale.salePayment.balance = 0;
                this.sale.salePayment.change = 0;
                this.sale.salePayment.paymentTypes = [];
                this.sale.otherCurrency.amount = 0;
                this.sale.otherCurrency.rate = 0;
                this.sale.salePayment.paymentType = ''

                //var root = this
                //setTimeout(function () {
                //    root.calculatorPanelOpen(true);
                //}, 375)


            },
            AutoIncrementCode: function () {
                var root = this;

                var token = "";
                if (root.$session.exists()) {
                    token = localStorage.getItem("token");
                }
                root.$https
                    .get("/Sale/SaleAutoGenerateNo?invoiceType=" + "Hold", {
                        headers: { Authorization: `Bearer ${token}` },
                    })
                    .then(function (response) {
                        if (response.data != null) {
                            if (root.sale.id == '00000000-0000-0000-0000-000000000000') {
                                root.sale.registrationNo = response.data.paid;
                                root.autoNumber = response.data.hold;
                                root.autoNumberCredit = response.data.credit;
                            }
                            else {
                                root.autoNumber = response.data.paid;
                            }
                        }
                    });
            },
            SaveSaleItems: function (saleItems) {
                this.sale.saleItems = saleItems;
            },
            saveSale: function (sale, isPrint, cashVoucher) {
                
                this.loading = true;
                var root = this;
                if (sale.invoiceType == "Hold") {
                    root.sale.invoiceType = sale.invoiceType;
                    root.sale.refrenceNo = sale.refrenceNo;
                    root.sale.salePayment.paymentType = 'Cash';
                }
                else {
                    root.sale.invoiceType = sale;
                }

                if (root.sale.isSaleReturnPost) {
                    root.sale.salePayment.paymentType = 'Cash';
                }

                if (cashVoucher == 'CashVoucher') {
                    this.sale.isCashVoucher = true;
                    root.headerFooter.printSizeA4 = 'CashVoucher'
                }

                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                if (this.sale.salePayment.received != 0) {
                    this.addPayment(this.sale.salePayment.received, this.sale.salePayment.paymentType, this.sale.salePayment.paymentName)
                }

                if (!this.sale.isCredit) {
                    this.sale.dueDate = moment().format("LLL");
                }
                if (this.sale.salePayment.dueAmount < 0) {
                    this.sale.salePayment.received = this.sale.salePayment.dueAmount;
                }
                this.sale.saleItems = this.saleProducts;
                this.sale.taxMethod = localStorage.getItem('taxMethod');

                this.$https
                    .post('/Sale/SaveSaleInformation', root.sale, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(response => {
                        
                        if (response.data.message.id != '00000000-0000-0000-0000-000000000000' && response.data.action == "Add") {
                            root.loading = false;
                            root.isPay = false;

                            if (root.sale.invoiceType == 'Paid') {
                                if (isPrint) {

                                    root.printId = response.data.message.id;
                                    if (root.headerFooter.printSizeA4 == 'Thermal') {
                                        root.isDoublePrint = response.data.message.isDoublePrint
                                        root.saleId = response.data.message.saleId
                                        root.PrintInvoice(root.printId);
                                    }
                                    else if (root.headerFooter.printSizeA4 == 'CashVoucher') {
                                        root.PrintCashVoucher(root.printId);
                                    }
                                    else {
                                        root.PrintInvoiceA4(root.printId);
                                    }


                                    var paid = '';
                                    if (this.$ServerIp.includes('localhost')) {

                                        var total1 = root.sale.salePayment.paymentTypes.reduce((total, prod) =>
                                            total + prod.amount, 0).toFixed(3).slice(0, -1);
                                        if (parseFloat(root.summary.withVat).toFixed(3).slice(0, -1) < 0) {
                                            paid = 'Payable Amount : ' + parseFloat(root.summary.withVat).toFixed(3).slice(0, -1);
                                        }
                                        else {
                                            paid = 'Total   : ' + parseFloat(root.summary.withVat).toFixed(3).slice(0, -1) + '<br>' +
                                                'Paid    : ' + total1 + '<br>' +
                                                'Balance : ' + root.sale.salePayment.change;
                                        }

                                        root.$swal({
                                            html: '<pre><h5>' + paid + '</h5></pre>',
                                            type: 'success',
                                            confirmButtonClass: "btn btn-primary",
                                            buttonStyling: false
                                        }).then(function (ok) {
                                            if (ok != null) {
                                                root.Reset(true);
                                            }
                                        });
                                    }
                                }
                                else {
                                    var total = root.sale.salePayment.paymentTypes.reduce((total, prod) =>
                                        total + prod.amount, 0).toFixed(3).slice(0, -1);

                                    if (parseFloat(root.summary.withVat).toFixed(3).slice(0, -1) < 0) {
                                        paid = 'Payable Amount : ' + parseFloat(root.summary.withVat).toFixed(3).slice(0, -1);
                                    }
                                    else {
                                        paid = 'Total   : ' + parseFloat(root.summary.withVat).toFixed(3).slice(0, -1) + '<br>' +
                                            'Paid    : ' + total + '<br>' +
                                            'Balance : ' + root.sale.salePayment.change;
                                    }

                                    root.$swal({
                                        html: '<pre><h5>' + paid + '</h5></pre>',
                                        type: 'success',
                                        confirmButtonClass: "btn btn-primary",
                                        buttonStyling: false
                                    }).then(function (ok) {
                                        if (ok != null) {
                                            root.Reset(true);
                                        }
                                    });
                                }
                            }
                            else {
                                root.Reset(true);
                            }
                        }
                        else if (response.data.message.id != '00000000-0000-0000-0000-000000000000' && response.data.action == "Update") {

                            root.loading = false;
                            root.$route.query.data = undefined;

                            if (root.sale.invoiceType == 'Paid') {
                                if (isPrint) {

                                    root.printId = response.data.message.id;
                                    if (root.headerFooter.printSizeA4 == 'Thermal') {
                                        root.isDoublePrint = response.data.message.isDoublePrint
                                        root.saleId = response.data.message.saleId
                                        root.PrintInvoice(root.printId);
                                    }
                                    else if (root.headerFooter.printSizeA4 == 'CashVoucher') {
                                        root.PrintCashVoucher(root.printId);
                                    }
                                    else {
                                        root.PrintInvoiceA4(root.printId);
                                    }


                                    var paid1 = '';
                                    if (this.$ServerIp.includes('localhost')) {

                                        var total2 = root.sale.salePayment.paymentTypes.reduce((total, prod) =>
                                            total + prod.amount, 0).toFixed(3).slice(0, -1);
                                        if (parseFloat(root.summary.withVat).toFixed(3).slice(0, -1) < 0) {
                                            paid1 = 'Payable Amount : ' + parseFloat(root.summary.withVat).toFixed(3).slice(0, -1);
                                        }
                                        else {
                                            paid1 = 'Total   : ' + parseFloat(root.summary.withVat).toFixed(3).slice(0, -1) + '<br>' +
                                                'Paid    : ' + total2 + '<br>' +
                                                'Balance : ' + root.sale.salePayment.change;
                                        }

                                        root.$swal({
                                            html: '<pre><h5>' + paid1 + '</h5></pre>',
                                            type: 'success',
                                            confirmButtonClass: "btn btn-primary",
                                            buttonStyling: false
                                        }).then(function (ok) {
                                            if (ok != null) {
                                                root.Reset(true);
                                            }
                                        });
                                    }
                                }
                                else {
                                    var total3 = root.sale.salePayment.paymentTypes.reduce((total, prod) =>
                                        total + prod.amount, 0).toFixed(3).slice(0, -1);

                                    if (parseFloat(root.summary.withVat).toFixed(3).slice(0, -1) < 0) {
                                        paid1 = 'Payable Amount : ' + parseFloat(root.summary.withVat).toFixed(3).slice(0, -1);
                                    }
                                    else {
                                        paid1 = 'Total   : ' + parseFloat(root.summary.withVat).toFixed(3).slice(0, -1) + '<br>' +
                                            'Paid    : ' + total3 + '<br>' +
                                            'Balance : ' + root.sale.salePayment.change;
                                    }

                                    root.$swal({
                                        html: '<pre><h5>' + paid1 + '</h5></pre>',
                                        type: 'success',
                                        confirmButtonClass: "btn btn-primary",
                                        buttonStyling: false
                                    }).then(function (ok) {
                                        if (ok != null) {
                                            root.Reset(true);
                                        }
                                    });
                                }
                            }
                            else {

                                root.Reset(true);
                            }
                        }
                        else {
                            root.$swal({
                                title: 'Error!',
                                text: response.data.message.isAddUpdate,
                                type: 'error',
                                confirmButtonClass: "btn btn-danger",
                                icon: 'error',
                                timer: 1500,
                                timerProgressBar: true,
                            });
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        root.$swal({
                            title: "Error!",
                            text: "Something went wrong. Please contact to support",
                            type: 'error',
                            icon: 'error',
                            buttonStyling: false,
                        });
                        root.loading = false;
                    })
                    .finally(() => (root.loading = false));
                root.sale.refrenceNo = ""
                root.barcode = ''
            },

            goToSale: function () {
                if (this.isValid('CanViewHoldInvoices') || this.isValid('CanViewPaidInvoices') || this.isValid('CanViewCreditInvoices')) {
                    this.$router.push('/sale');
                }
                else {
                    this.$router.go();
                }
            },

            calcuateSummary: function () {

                this.summary.item = this.saleProducts.filter(prod => prod.quantity > 0).length;


                if (this.decimalQuantity) {
                    this.summary.qty = this.saleProducts.reduce((qty, prod) => qty + (parseFloat(prod.quantity) > 0 ? parseFloat(prod.quantity) : 0), 0);
                    this.summary.qty = parseFloat(this.summary.qty).toFixed(2);
                }
                else {
                    this.summary.qty = this.saleProducts.reduce((qty, prod) =>
                        qty + (parseInt(prod.quantity) > 0 ? parseInt(prod.quantity) : 0), 0);
                }


                this.summary.total = this.saleProducts.reduce((total, prod) =>
                    total + (prod.quantity) * prod.unitPrice, 0).toFixed(3).slice(0, -1);


                var discount = this.saleProducts.filter((x) => x.discount != 0 || x.discount != "")
                    .reduce((discount, prod) => discount +
                        prod.diff ?
                        ((prod.diff * prod.unitPrice * prod.discount) / 100) :
                        ((prod.quantity < (prod.offerQuantity > prod.remainingStockLimit ? prod.remainingStockLimit : prod.offerQuantity)) ? ((prod.quantity * prod.unitPrice * prod.discount) / 100) :
                            ((prod.offerQuantity > prod.remainingStockLimit ? prod.remainingStockLimit : prod.offerQuantity) * prod.unitPrice * prod.discount) / 100), 0);

                /*just calculate discount without promotion*/
                var discountOnly = this.saleProducts
                    .filter((x) => x.discount != 0 || x.discount != "" || x.offerQuantity != 0)
                    .reduce((discount, prod) =>
                        discount + (prod.quantity ? (prod.offerQuantity ? 0 : ((prod.quantity * prod.discount * prod.unitPrice) / 100)) : 0), 0);

                var fixDiscount = this.saleProducts
                    .filter((x) => x.fixDiscount != 0 || x.fixDiscount != "")
                    .reduce((discount, prod) =>
                        discount + prod.offerQuantity ? ((prod.quantity < (prod.offerQuantity > prod.remainingStockLimit ? prod.remainingStockLimit : prod.offerQuantity)) ? prod.fixDiscount * prod.quantity : prod.fixDiscount * (prod.offerQuantity > prod.remainingStockLimit ? prod.remainingStockLimit : prod.offerQuantity)) : 0, 0);

                /*just calculate fix discount without promotion*/
                var fixDiscountOnly = this.saleProducts
                    .filter((x) => x.fixDiscount != 0 || x.fixDiscount != "" || x.offerQuantity != 0)
                    .reduce((discount, prod) =>
                        discount + (prod.quantity ? (prod.offerQuantity ? 0 : (prod.quantity * prod.fixDiscount)) : 0), 0);


                this.summary.discount = (parseFloat(discount) + parseFloat(fixDiscount) + fixDiscountOnly + discountOnly).toFixed(3).slice(0, -1);

                this.summary.withDisc = (this.summary.total - this.summary.discount).toFixed(3).slice(0, -1);

                this.summary.vat = this.saleProducts
                    .reduce((vat, prod) => vat + prod.lineItemVAt, 0).toFixed(3).slice(0, -1);
                var taxmethod = this.saleProducts.find(function (x) {
                    return x.taxMethod == ("Inclusive" || "شامل")
                })
                if (this.summary.vat == 'NaN') {
                    this.summary.vat = 0;
                }

                this.summary.withVat = (parseFloat(this.summary.withDisc) + ((taxmethod == undefined) ? parseFloat(this.summary.vat) : 0)).toFixed(3).slice(0, -1);

                if (this.summary.withVat == 'NaN') {
                    this.summary.withVat = 0;
                }
                //calculate bundle Amount
                if (this.saleProducts.filter(x => x.isBundleOffer).length > 0) {

                    //get bundle get quantity
                    var bundle = {
                        item: 0,
                        qty: 0,
                        total: 0,
                        discount: 0,
                        withDisc: 0,
                        vat: 0,
                        withVat: 0,
                        quantityLimit: 0
                    };

                    var bundleProducts = this.saleProducts.filter(x => x.isBundleOffer != undefined && x.offerQuantity > 0);

                    bundle.total = bundleProducts.reduce((total, prod) =>
                        total + prod.offerQuantity * prod.unitPrice, 0).toFixed(3).slice(0, -1);

                    //var bundleExclusiveTax = bundleProducts.reduce((total, prod) =>
                    //    total + (prod.taxMethod == "Exclusive" ? (bundle.total * prod.rate/100) : 0), 0);

                    var discountBundle = bundleProducts.filter((x) => x.discount != 0 || x.discount != "")
                        .reduce((discount, prod) =>
                            discount + (prod.offerQuantity * prod.unitPrice * prod.discount) / 100, 0);

                    var fixDiscountBundle = bundleProducts
                        .filter((x) => x.fixDiscount != 0 || x.fixDiscount != "")
                        .reduce((discount, prod) => discount + prod.fixDiscount, 0);

                    bundle.discount = (parseFloat(discountBundle) + parseFloat(fixDiscountBundle)).toFixed(3).slice(0, -1);

                    bundle.withDisc = (bundle.total - bundle.discount).toFixed(3).slice(0, -1);

                    bundle.vat = bundleProducts
                        .reduce((vat, prod) => vat + (((prod.unitPrice * prod.offerQuantity) -
                            ((prod.unitPrice * prod.offerQuantity * prod.discount) / 100)) *
                            parseFloat(prod.rate)) / ((prod.taxMethod == "Exclusive" || prod.taxMethod == "غير شامل") ? 100 : prod.rate + 100), 0).toFixed(3).slice(0, -1);

                    this.summary.bundleAmount = (parseFloat(bundle.withDisc) + ((taxmethod == undefined) ? parseFloat(bundle.vat) : 0)).toFixed(3).slice(0, -1);
                    this.summary.withVat = (this.summary.withVat - bundle.withDisc);


                } else {
                    this.summary.bundleAmount = 0;
                }
                this.$emit("input", this.saleProducts);

                this.$emit("summary", this.summary);
                this.updateSummary();
            },

            //productRemainingQuantity: function (id, qnty) {
            //    var prod = this.products.find((x) => x.id == id);
            //    prod.inventory.currentQuantity = prod.inventory.currentQuantity - qnty;
            //},
            updateLineTotal: function (e, prop, product) {

                if (e != undefined) {
                    var discount = product.discount == 0 || product.discount == "" ? product.fixDiscount == 0 || product.fixDiscount == ""
                        ? 0
                        : product.fixDiscount
                        : product.discount;

                    var prod = this.products.find((x) => x.id == product.productId);
                    if (prop == "unitPrice") {
                        product.unitPrice = e;
                    }

                    if (product.returnQuantity != undefined && product.returnQuantity > 0) {
                        product.quantity = product.quantity * -1;
                    }
                    if (prop == "quantity") {

                        if (this.sale.isReturnItem && (product.returnQuantity == 0 || product.returnQuantity == '')) {
                            this.removeProduct(product.rowId)
                        }
                        else if (this.sale.isReturnItem && product.returnQuantity > 0) {
                            e = e * -1;
                        }
                        else {
                            if (e < 0) {
                                e = '';
                            }
                        }
                        if (String(e).split('.').length > 1 && String(e).split('.')[1].length > 2)
                            e = parseFloat(String(e).slice(0, -1))
                        product.quantity = this.decimalQuantity ? e : Math.round(e);
                    }

                    if (prod.promotionOffer != null) {
                        if (product.quantity > 0 && moment().format("LLL") >= moment(prod.promotionOffer.fromDate).format("LLL") &&
                            moment().format("LLL") <= moment(prod.promotionOffer.toDate).format("LLL")) {
                            product.fixDiscount = prod.promotionOffer.fixedDiscount;
                            product.discount = prod.promotionOffer.discountPercentage;
                            product.offerQuantity = prod.promotionOffer.quantity;
                            this.$set(product, 'isOfferQty', true);
                        } else {
                            if (product.isOfferQty) {
                                product.fixDiscount = 0;
                                product.discount = 0;
                                product.offerQuantity = 0;
                            }
                            this.$set(product, 'isOfferQty', false);
                        }
                    }

                    if (prod.bundleCategory != null) {
                        if (product.quantity >= prod.bundleCategory.buy && moment().format("LLL") >= moment(prod.bundleCategory.fromDate).format("LLL") &&
                            moment().format("LLL") <= moment(prod.bundleCategory.toDate).format("LLL")) {
                            this.$set(product, 'bundleOffer', prod.bundleCategory.buy.toString() + " + " + prod.bundleCategory.get.toString());
                            this.$set(product, 'get', prod.bundleCategory.get);
                            this.$set(product, 'buy', prod.bundleCategory.buy);
                            this.$set(product, 'quantityLimit', prod.bundleCategory.quantityLimit);
                            this.$set(product, 'isBundleOffer', true);
                        } else {
                            this.$set(product, 'bundleOffer', "");
                            this.$set(product, 'get', 0);
                            this.$set(product, 'buy', 0);
                            this.$set(product, 'quantityLimit', 0);
                            this.$set(product, 'isBundleOffer', false);
                        }
                        //bundle category calculation
                        if (product.quantityLimit != undefined && parseFloat(product.quantity) >= (product.get + product.buy)) {
                            if ((product.get + product.buy) > 0) {
                                product.offerQuantity = Math.floor(parseFloat(product.quantity) / (product.get + product.buy));
                                if ((prod.bundleCategory.quantityOut + product.offerQuantity) <= prod.bundleCategory.stockLimit) {
                                    if (product.offerQuantity <= product.quantityLimit) {
                                        product.offerQuantity = product.offerQuantity * product.get;
                                    }
                                    else {
                                        product.offerQuantity = product.quantityLimit * product.get;
                                    }
                                }
                                else {
                                    var diffBundle = prod.bundleCategory.stockLimit - prod.bundleCategory.quantityOut;
                                    if (diffBundle > product.quantityLimit) {
                                        product.offerQuantity = product.quantityLimit * product.get;
                                    }
                                    else {
                                        product.offerQuantity = diffBundle * product.get;
                                    }
                                }
                            }
                            else {
                                product.offerQuantity = 0;
                            }
                        }
                        else {
                            if ((product.get + product.buy) > 0) {
                                product.offerQuantity = Math.floor(parseFloat(product.quantity) / (product.get + product.buy));
                            }
                            else {
                                product.offerQuantity = 0;
                            }
                        }
                        //bundle category calculation end
                    }

                    if (this.invoiceWoInventory == 'false') {
                        var bundleQuantity = product.bundleOfferQuantity == undefined ? 0 : product.bundleOfferQuantity;
                        if (prod.inventory != null) {
                            if (parseFloat(product.quantity) + bundleQuantity > prod.inventory.currentQuantity) {
                                this.$set(product, 'outOfStock', true);
                            } else {
                                this.$set(product, 'outOfStock', false);
                            }
                        } else {
                            this.$set(product, 'outOfStock', true);
                        }
                    }

                    //End Calculate offer
                    if (prop == "discount") {
                        if (e == "") {
                            e = 0;
                        }
                        product.discount = e;
                    }

                    if (prop == "fixDiscount") {
                        if (e == "") {
                            e = 0;
                        }
                        product.fixDiscount = e;
                    }

                    var vat = 0;
                    var total = 0;
                    var calculateVAt = 0;
                    //here we will select quantity after deduct bundle quantity
                    if (product.offerQuantity > 0) {

                        if (product.isOfferQty) {
                            if (product.quantity > 0) {
                                if ((product.quantity) <= (prod.promotionOffer.stockLimit - prod.promotionOffer.quantityOut)) {
                                    this.$set(product, 'remainingStockLimit', (prod.promotionOffer.stockLimit - prod.promotionOffer.quantityOut));

                                    if (product.quantity <= product.offerQuantity) {
                                        discount = product.discount == 0 ? (product.fixDiscount * product.quantity) : (product.quantity * product.unitPrice * product.discount) / 100;

                                    }
                                    else {
                                        discount = product.discount == 0 ? (product.fixDiscount * product.offerQuantity) : (product.offerQuantity * product.unitPrice * product.discount) / 100;
                                    }
                                }
                                else {
                                    discount = product.discount == 0 ? (product.fixDiscount * (prod.promotionOffer.stockLimit - prod.promotionOffer.quantityOut)) : ((prod.promotionOffer.stockLimit - prod.promotionOffer.quantityOut) * product.unitPrice * product.discount) / 100;
                                }

                                vat = this.vats.find((value) => value.id == product.taxRateId);
                                total = product.quantity * product.unitPrice - discount;
                                if (product.taxMethod == 'Inclusive' || product.taxMethod == 'شامل') {
                                    calculateVAt = (total * vat.rate) / (100 + vat.rate);
                                    product.lineItemVAt = calculateVAt;
                                    /*product.lineTotal = total - calculateVAt;*/
                                    product.lineTotal = total;
                                }
                                else {
                                    calculateVAt = (total * vat.rate) / 100;
                                    product.lineItemVAt = calculateVAt;
                                    product.lineTotal = total + calculateVAt;
                                }

                            } else {
                                total = product.offerQuantity * product.unitPrice - discount;
                                if (product.taxMethod == 'Inclusive' || product.taxMethod == 'شامل') {
                                    calculateVAt = (total * vat.rate) / (100 + vat.rate);
                                    product.lineItemVAt = calculateVAt;
                                    /*product.lineTotal = total - calculateVAt;*/
                                    product.lineTotal = total;
                                }
                                else {
                                    calculateVAt = (total * vat.rate) / 100;
                                    product.lineItemVAt = calculateVAt;
                                    product.lineTotal = total + calculateVAt;
                                }
                            }
                        } else {
                            discount = product.discount == 0 ? product.fixDiscount : (product.offerQuantity * product.unitPrice * product.discount) / 100;
                            vat = this.vats.find((value) => value.id == product.taxRateId);

                            total = (product.quantity - product.offerQuantity) * product.unitPrice - discount;
                            if (product.taxMethod == 'Inclusive' || product.taxMethod == 'شامل') {
                                calculateVAt = (total * vat.rate) / (100 + vat.rate);
                                product.lineItemVAt = calculateVAt;
                                /*product.lineTotal = total - calculateVAt;*/
                                product.lineTotal = total;
                            }
                            else {
                                calculateVAt = (total * vat.rate) / 100;
                                product.lineItemVAt = calculateVAt;
                                product.lineTotal = total + calculateVAt;
                            }
                        }

                        this.$set(this.saleProducts, product, product);
                        this.calcuateSummary();
                        this.$emit("input", this.saleProducts);

                    }
                    else {

                        discount = product.discount == 0 ? (product.fixDiscount * product.quantity) : (product.quantity * product.unitPrice * product.discount) / 100;
                        vat = this.vats.find((value) => value.id == product.taxRateId);

                        total = product.quantity * product.unitPrice - discount;
                        if (product.taxMethod == 'Inclusive' || product.taxMethod == 'شامل') {
                            calculateVAt = (total * vat.rate) / (100 + vat.rate);
                            /*product.lineTotal = total - calculateVAt;*/
                            product.lineTotal = total;
                            product.lineItemVAt = calculateVAt;
                        }
                        else {
                            calculateVAt = (total * vat.rate) / 100;
                            product.lineTotal = total + calculateVAt;
                            product.lineItemVAt = calculateVAt;
                        }

                        this.$set(this.saleProducts, product, product);
                        this.calcuateSummary();
                        this.$emit("input", this.saleProducts);
                    }
                    //this.productRemainingQuantity(product.productId, product.quantity);
                    this.quantity = product.quantity;
                    this.quantityRander++;
                }

            },
            addProduct: function (productId, newProduct, quantitychange) {

                if (this.isOldInvoice) {
                    this.sale.returnInvoiceAmount = this.summary.withVat
                    this.isOldInvoice = false
                }
                this.styleclass = productId;
                if (this.styleclass == productId) {
                    this.isCardColor = true;
                }

                if (quantitychange != null || quantitychange != undefined) {
                    this.isSaleReturn = quantitychange;
                }
                this.products.push(newProduct);
                if (this.saleProducts.some(x => x.productId == productId)) {
                    var prd = this.saleProducts.find(x => x.productId == productId);
                    if (quantitychange != undefined || quantitychange != null) {
                        if (!this.isSaleReturn) {
                            prd.quantity--;
                        }
                        if (this.isSaleReturn) {
                            prd.quantity++;
                        }
                    }

                    this.updateLineTotal(prd.quantity, "quantity", prd);
                }
                else {

                    if (this.products.find(x => x.id == newProduct.id) == undefined || this.products.length <= 0) {
                        this.products.push(newProduct);
                    }
                    var prod = this.products.find((x) => x.id == productId);

                    var rate = this.getVatValue(prod.taxRateId, prod);

                    if (this.isSaleReturn) {
                        this.saleProducts.push({
                            rowId: this.createUUID(),
                            productId: prod.id,
                            productName: prod.englishName,
                            code: prod.code,
                            unitPrice: prod.salePrice,
                            quantity: -1,
                            discount: 0,
                            fixDiscount: 0,
                            taxRateId: prod.taxRateId,
                            promotionId: prod.promotionOffer == null ? null : prod.promotionOffer.id,
                            bundleId: prod.bundleCategory == null ? null : prod.bundleCategory.id,
                            saleReturnDays: prod.saleReturnDays,
                            rate: rate,
                            taxMethod: prod.taxMethod,
                            lineTotal: prod.salePrice * 1,
                            buy: prod.bundleCategory != null ? prod.bundleCategory.buy : 0,
                            get: prod.bundleCategory != null ? prod.bundleCategory.get : 0,
                            quantityLimit: prod.bundleCategory != null ? prod.bundleCategory.quantityLimit : 0,
                            offerQuantity: 0
                        });
                    }
                    if (!this.isSaleReturn) {

                        this.saleProducts.push({
                            rowId: this.createUUID(),
                            productId: prod.id,
                            productName: prod.englishName,
                            code: prod.code,
                            unitPrice: prod.salePrice == 0 ? '0' : prod.salePrice,
                            quantity: 1,
                            discount: 0,
                            fixDiscount: 0,
                            taxRateId: prod.taxRateId,
                            promotionId: prod.promotionOffer == null ? null : prod.promotionOffer.id,
                            bundleId: prod.bundleCategory == null ? null : prod.bundleCategory.id,
                            taxMethod: prod.taxMethod,
                            saleReturnDays: prod.saleReturnDays,
                            rate: rate,
                            lineTotal: prod.salePrice * 1,
                            buy: prod.bundleCategory != null ? prod.bundleCategory.buy : 0,
                            get: prod.bundleCategory != null ? prod.bundleCategory.get : 0,
                            quantityLimit: prod.bundleCategory != null ? prod.bundleCategory.quantityLimit : 0,
                            offerQuantity: 0
                        });

                    }
                }
                var product = this.saleProducts.find((x) => {
                    return x.productId == productId;
                });

                this.getVatValue(product.taxRateId, product);
                this.updateLineTotal(product.quantity, "quantity", product);

                this.product.id = "";
                this.rendered++;
            },

            createUUID: function () {
                var dt = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (dt + Math.random() * 16) % 16 | 0;
                    dt = Math.floor(dt / 16);
                    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid;
            },

            GetHeaderDetail: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get("/Company/GetCompanyDetail?id=" + root.companyId, { headers: { Authorization: `Bearer ${token}` }, })
                    .then(function (response) {
                        if (response.data != null) {
                            root.headerFooter.company = response.data;
                            if (root.overWrite) {

                                root.headerFooter.company.nameArabic = root.BusinessNameArabic;
                                root.headerFooter.company.nameEnglish = root.BusinessNameEnglish;
                                root.headerFooter.company.categoryArabic = root.BusinessTypeArabic;
                                root.headerFooter.company.categoryEnglish = root.BusinessTypeEnglish;

                                root.headerFooter.company.companyNameArabic = root.CompanyNameArabic;
                                root.headerFooter.company.companyNameEnglish = root.CompanyNameEnglish;
                                root.headerFooter.company.logoPath = root.BusinessLogo;
                            }
                            root.GetInvoicePrintSetting();
                            root.getBase64Image(root.headerFooter.company.logoPath);
                        }
                    });
            },
            GetInvoicePrintSetting: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('/Sale/printSettingDetail', { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null && response.data != '') {

                            root.headerFooter.footerEn = response.data.termsInEng;
                            root.headerFooter.footerAr = response.data.termsInAr;
                            root.headerFooter.isHeaderFooter = response.data.isHeaderFooter;
                            root.headerFooter.englishName = response.data.englishName;
                            root.headerFooter.arabicName = response.data.arabicName;
                            root.headerFooter.customerAddress = response.data.customerAddress;
                            root.headerFooter.customerVat = response.data.customerVat;
                            root.headerFooter.customerNumber = response.data.customerNumber;
                            root.headerFooter.cargoName = response.data.cargoName;
                            root.headerFooter.customerTelephone = response.data.customerTelephone;
                            root.headerFooter.itemPieceSize = response.data.itemPieceSize;
                            root.headerFooter.styleNo = response.data.styleNo;
                            root.headerFooter.blindPrint = response.data.blindPrint;
                            root.headerFooter.showBankAccount = response.data.showBankAccount;
                            root.headerFooter.bankAccount1 = response.data.bankAccount1;
                            root.headerFooter.bankAccount2 = response.data.bankAccount2;
                            root.headerFooter.bankIcon1 = response.data.bankIcon1;
                            root.headerFooter.bankIcon2 = response.data.bankIcon2;
                            root.headerFooter.customerNameEn = response.data.customerNameEn;
                            root.headerFooter.customerNameAr = response.data.customerNameAr;
                            root.headerFooter.exchangeDays = response.data.exchangeDays;
                            root.headerFooter.printOptions = response.data.printOptions;
                            root.headerFooter.invoicePrint = response.data.invoicePrint;
                            root.headerFooter.welcomeLineEn = response.data.welcomeLineEn;
                            root.headerFooter.welcomeLineAr = response.data.welcomeLineAr;
                            root.headerFooter.closingLineEn = response.data.closingLineEn;
                            root.headerFooter.closingLineAr = response.data.closingLineAr;
                            root.headerFooter.contactNo = response.data.contactNo;
                            root.headerFooter.managementNo = response.data.managementNo;
                            root.headerFooter.businessAddressArabic = response.data.businessAddressArabic;
                            root.headerFooter.businessAddressEnglish = response.data.businessAddressEnglish;
                        }
                    },
                        function (error) {
                            this.loading = false;
                            console.log(error);
                        });
            },

            getBase64Image: function (path) {
                var root = this;
                var token = '';
                if (root.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.headerFooter.company.logoPath = 'data:image/png;base64,' + 'iVBORw0KGgoAAAANSUhEUgAAATYAAACjCAMAAAA3vsLfAAAAhFBMVEX///8AcuEAZ98Ab+AAa+AAbeAAad9Tk+cAbuC+1fUFeOLS4/no8/0AZd8AaODv9v1to+vk7/z1+v7d6vqBru3F2vemxfKHsu5Zl+iYvfDU5PnM3/g9iea20PWNte5Rk+gwhOVIjuepx/NjnOl2p+wlfuS30fUAX96cvvAde+M1huWoxfIDNGHbAAAHKElEQVR4nO2d65aiOhBGJQlpVAKId6VVtJ3ROe//fgfvqSQocS3EjrV/NsEJ38qlqlKVabUQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEGQ30E6nG6ybcfrbPNkN2+6N68kDWVimzdHOYlYEFDP8yj1GWGT79q6+W7kQoZWfi/8IfwgmEzA/UVaY1/fiCX49k7V1wbC90wwMq2zt2/D1zOyDSkzinaAb/v19vgteEa2hSgV7TBVxQcscU/IlpB7qhUI9yeqvWxJ9EC1QrdR7f1uGGvZpndn6EW3Yf09bxRb2WZVVCsWOMcNEVvZtqqxZsafvKDvDWIp245XUq2Ypm77WpayaWONRYIxwTXjl2av6H1j2Mm2VgYb88bzwo8Nhz9MFU50X9L/hrCTbQVHmxhcn8QbxS7xk3o73ixWsvXgNgrdgYViBbM6u900VrLBORrt4NMf6KgSlzcFK9k2gdRWX/SV0eayi2Ul215uTLQ1/xsMxmBTV5/fACvZ5KWNGtoC2eiqlg6/BzayxbJs/o/eIAc/Vj1U/PuwkQ1spGynNxgA443X1OV3wEa2viwbNwQjFwxl0wGjja/1BlA2lw23p9c2k33xAz2smrr8DljtpLL/ZLIvgO8VuOzMW8kGZNE3yhi4V047pVaygUnI/6iPp3BHcPlAwUo24AZo9m4Ko0rC5fNSK9nAnuAxZRZmAZDN5R3BMt4G3QAykJ9NYACEjWvsdeMosg3bJZxO8Nowpsaz60Scb5X8BtFr7JteAJTN42X8PeVwdWBzKrLdcDZrL1ZCOWVwOv6hyVYKP8n2Rz0mpYyTiDPtV9webLaytfLgcdtDc6dXNnvZwvIULQm6bfarasdWtla7SjYDc3uKPiFba/dYN8eP5FvPyNYaPdCNEtfzjZ6SrTWM7u0LzHPZqzrzjGytOFfNtNtQEy4HPq48JVvh1Hci04tUrJxf1o48KVurtV4JxcgNmMjbjXzE61lWlC3SC2Rm41UUMRYU+IWvwLKp62bHjaUgMtERyRdlB/wCY1ZpPByNk8lkkizWXcfTTiHxrKB/otfrnUuvIGlB0/1EnKQ3/16P1t/DiutUf3hsPv+cZU2nu8gOYaADEWHL0QMt5uMVuTbn+XT2ml6+F+HCIwwksBUGRbmbFI6L5uAAkJHO7tPWwDiJDCEhKnKzpxQmxNScs/FHCTfVU+TPNiwxZBaVN/cY/YD6vjNxdqf8jGinAnebe8LtU4QbM/9upJsvYfN+cD8wzrY2Jfe/lpnRK5d1+LJq7gXeB+hW4XQgWsjNH3uxgetHCa1qNXtiZtXcY86vb4MqNXvByqq5WiDjHn218D1gJGJcMeLo37MM/WpVuMUbbttvE7grUpKNZnEaz8e+L/1xewk/fmmbKPUZ8/WJyxZ3/9lfjjJ62PYa004nZ+OMRvvrjNNKvhnPB9Ppzz/dxWAuD7cBzO0Gpdrj4/yNOtIylUDngPKLExqO1UMZp5MpgQx+Dh8mzOMeyKOHY8pfSfZZ31OSkVYv6H5DdOGGoD72oGitYXRHmFiZpSKstetNApKUIy2HWY1+jGFOs+ILdOHCZyqTcQRQIHrNQO13z8xmXYkZzEHV6zngyucP1OfOIJv8t8/cwNOsM6IDV0KubZXQBqS5+twZ5EnHr0fDiTGYRv/BetKl/nMgRZXuX/klrwQkzJPrSlYi2xLWXBns2QQYw86WqoWyDtF15zPLFmxCuwo/ZwsjgQ7kgWz+IHxUTzr9DNlSINs1OGSWje3AJOX/6b8HDRT/lZ/yUkDp2XX4mGWLhmBLYAb7Al544W6sUq50vBUylsjWAxd9mJwn0D5w9y4ysPVdJ5VZNk9JhiPamf0c+F4OF12N5Fgtv5j9RtkOgwcs+fqNFrCQjbubIgjDbZe9dPP3dOczkWU4GBzQ81evGlvDuIBwOOAG7frO6UvjS5ZbJj09mnVwAHIQ45hDT97kRTgDtLRoRxYizXxVBWhhUCZl1ihjzRBPcYgYpiVQPr1MrXQHzupPJRqhog2ZnILoaVvLb6h8PfmvRLl0zeP+ZtQeDkdJYLznKVGaB1GwWi5XvnZSHxl8L4eItbOTgPGIc+WE6nL/sN7cowXaH50/lx89uiH8wO0aXXUJK0E4n1mZl6WqSbBb/PurSkEpcfqU9EjqPczqAIWO28f1y9xdv+pGaFiboGpgeU/3j4anmhDnKOH+7sQTyqaYZvfTZz6jxu/ApjwjJmB6tvigtC7ykOzr8nG8wndgHnBU5KbMyPm2JKWyaP9RhR3pmGv/AZNHyb7MRVp3iL41+GTlbtijhHS3F1I5R+BzsrwnQvuLcKk9ZRFPnL5+vZT+buKJw9myECwbtB9FftL2IGPn9nS5cP9igTukvUOJZPVY2bF96HBsDUEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQmf8BckJbXFsgizoAAAAASUVORK5CYII=';

                root.$https
                    .get('/Contact/GetBaseImage?filePath=' + path, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {

                        if (response.data != null) {
                            root.filePath = response.data;
                            root.headerFooter.company.logoPath = 'data:image/png;base64,' + root.filePath;
                        }

                    });
            },
            PrintCashVoucher: function (value) {
                this.GetHeaderDetail();
                var id = value;
                var root = this;
                this.isTouchScreen = true;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.printDetails = [];
                root.printDetailsPos = [];
                root.$https.get("/Sale/SaleDetail?id=" + id, { headers: { Authorization: `Bearer ${token}` }, })
                    .then(function (response) {
                        if (response.data != null) {
                            root.printDetailsCashVoucher = response.data;
                            root.printRender++;

                        }
                    });
            },
            PrintInvoice: function (value) {

                var id = value;
                var root = this;
                this.isTouchScreen = true;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.printDetails = [];
                root.printDetailsCashVoucher = [];
                root.$https.get("/Sale/SaleDetail?id=" + id, { headers: { Authorization: `Bearer ${token}` }, })
                    .then(function (response) {
                        if (response.data != null) {

                            root.printDetailsPos = response.data;
                            root.printRender++;

                        }
                    });

            },
            PrintInvoiceA4: function (value) {

                var id = value;
                var root = this;
                var token = '';

                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.printDetailsPos = [];
                root.printDetailsCashVoucher = [];
                root.$https.get("/Sale/SaleDetail?id=" + id, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                    .then(function (response) {
                        if (response.data != null) {
                            root.printDetails = response.data;
                            root.printRender++;
                        }
                    });
            },
            CounterDetail: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                if (root.counterCode == 'null' || root.counterCode == 'undefined' || root.counterCode == null || root.counterCode == undefined) {
                    this.$https.get('/Product/OpeningBalance?counterId=' + this.sale.counterId + '&isOpeningCash=' + false, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {

                        if (response.data != null) {
                            root.counterCode = response.data.terminalCode;
                            localStorage.setItem('CounterCode', root.counterCode);
                        }
                    });
                }
            },
            UpdateProductData: function () {
                
                this.addProduct(this.selectedProductValue.id, this.produc.find(x => x.id == this.selectedProductValue.id));
                this.selectedProductValue = '';
                this.barcode = ''
            },
        },
        created: function () {
            
            var root = this;
            //For Scanner Code
            //var barcode = '';
            var interval;
            document.addEventListener('keydown', function (evt) {
                if (interval)
                    clearInterval(interval);
                if (evt.keyCode === 13) {

                    if (root.sale.salePayment.received > 0)
                        root.addPayment(root.sale.salePayment.received, root.sale.salePayment.paymentType, root.sale.salePayment.paymentName)
                    else if (root.barcode.length > 0) {
                        root.onBarcodeScanned(root.barcode)
                    }
                    root.barcode = '';
                    return;
                }
                if (evt.key !== 'Shift' || evt.key !== 'Backspace' || evt.key !== 'Delete')
                    root.barcode += evt.key;
            });
            localStorage.setItem("BarcodeScan", 'TouchScreenForBar')

            //End
            //if (!reading) {
            //    reading = true;
            //    setTimeout(() => {
            //        code = "";
            //        reading = false;
            //    }, 200);  //200 works fine for me but you can adjust it
            //}






            root.counterCode = localStorage.getItem('CounterCode');
            root.dayStartTime = localStorage.getItem('DayStartTime');
            //this.$barcodeScanner.init(this.onBarcodeScanned);

            root.headerFooter.returnDays = localStorage.getItem('ReturnDays');
            root.headerFooter.footerEn = localStorage.getItem('TermsInEng');
            root.headerFooter.footerAr = localStorage.getItem('TermsInAr');
            root.headerFooter.printSizeA4 = localStorage.getItem('PrintSizeA4');
            this.companyId = localStorage.getItem('CompanyID');
            if (this.$route.query.data != undefined) {
                var data = this.$route.query.data;
                this.sale.id = data.id;
                this.sale.wareHouseId = data.wareHouseId;
                this.sale.invoiceType = data.invoiceType;
                this.sale.cashCustomer = data.cashCustomer;
                this.sale.date = moment(data.date).format("LLL");
                this.sale.dueDate = moment(data.dueDate).format("LLL");
                this.sale.registrationNo = data.registrationNo;
                this.sale.mobile = data.mobile;
                this.sale.code = data.code;
                this.sale.customerId = data.customerId;
                this.sale.saleItems = data.saleItems;
                this.sale.salePayment = {
                    dueAmount: 0,
                    received: 0,
                    balance: 0,
                    change: 0,
                    paymentTypes: [],
                    paymentType: 'Cash',
                    paymentOptionId: '',
                };
            }
            else {
                this.sale.wareHouseId = localStorage.getItem('WareHouseId');
            }
            this.getData();
            if (this.$route.query.mobiledata != undefined) {
                //root.purchaseProducts = root.$route.query.data.mobileOrderItemLookupModels;
                for (var j = 0; j < this.$route.query.mobiledata.mobileOrderItemLookupModels.length; j++) {

                    /*  this.saleProducts.rowId[j] = this.$route.query.mobiledata.mobileOrderItemLookupModels[j].id[j];*/
                    this.saleProducts.quantity[j] = this.$route.query.mobiledata.mobileOrderItemLookupModels[j].quantity[j];
                    //root.updateLineTotal(root.purchaseProducts[j].quantity, "quantity", root.purchaseProducts[j]);
                    //root.updateLineTotal(root.purchaseProducts[j].unitPrice, "unitPrice", root.purchaseProducts[j]);

                }
                root.calcuateSummary();
                this.saleProducts.rowId = this.$route.query.mobiledata.mobileOrderItemLookupModels.rowId;
                this.saleProducts.quantity = this.$route.query.mobiledata.mobileOrderItemLookupModels.quantity;
            }
            this.itemRender++;
        },
        mounted: function () {
            
            this.GetHeaderDetail();
            this.overWrite = localStorage.getItem('overWrite') == 'true' ? true : false;
            this.taxMethod = localStorage.getItem('taxMethod');
            this.sale.taxRateId = localStorage.getItem('TaxRateId');
            this.BusinessLogo = localStorage.getItem('BusinessLogo');
            this.BusinessNameArabic = localStorage.getItem('BusinessNameArabic');
            this.BusinessNameEnglish = localStorage.getItem('BusinessNameEnglish');
            this.BusinessTypeArabic = localStorage.getItem('BusinessTypeArabic');
            this.BusinessTypeEnglish = localStorage.getItem('BusinessTypeEnglish');
            this.CompanyNameArabic = localStorage.getItem('CompanyNameArabic');
            this.CompanyNameEnglish = localStorage.getItem('CompanyNameEnglish');
            this.bankDetail = localStorage.getItem('BankDetail') == 'true' ? true : false;
            this.decimalQuantity = localStorage.getItem('decimalQuantity') == 'true' ? true : false;
            this.loginUserName = localStorage.getItem('LoginUserName');
            var IsDayStart = localStorage.getItem('DayStart');
            var IsExpenseDay = localStorage.getItem('IsExpenseDay');
            var IsDayStartOn = localStorage.getItem('IsDayStart');
            this.currency = localStorage.getItem('currency');
            this.invoiceWoInventory = localStorage.getItem('InvoiceWoInventory');
            this.cashVoucherAllow = localStorage.getItem('CashVoucher');
            this.sale.dayStart = IsDayStart == 'false' ? false : true;
            this.sale.counterId = localStorage.getItem('CounterId');
            this.printTemplate = localStorage.getItem('PrintTemplate');
            this.printSize = localStorage.getItem('PrintSizeA4');


            if (IsDayStart != 'true') {
                this.isDayAlreadyStart = true;
                this.getBank();

                this.getCurrency();
                this.GetCategoryData(this.search, true);
                if (this.$route.query.data == undefined) {
                    this.sale.date = moment().format("LLL");
                    this.sale.dueDate = moment().format("LLL");
                }
                this.AutoIncrementCode();

                if (this.$route.query.data != undefined) {
                    this.warehouse = this.$route.query.data;
                }
                if (this.$route.query.mobiledata != undefined) {
                    this.sale.date = this.$route.query.mobiledata.orderDate;
                }
                this.changePriceDuringSale = localStorage.getItem('changePriceDuringSale');
                this.changePriceDuringSale == 'true' ? (this.changePriceDuringSale = true) : (this.changePriceDuringSale = false);
                this.giveDiscountDuringSale = localStorage.getItem('giveDicountDuringSale');
                this.giveDiscountDuringSale == 'true' ? (this.giveDiscountDuringSale = true) : (this.giveDiscountDuringSale = false);
                root.CounterDetail();
            }
            else {
                if (IsExpenseDay == 'true') {
                    this.isDayAlreadyStart = false;
                }
                else {
                    this.CompanyID = localStorage.getItem('CompanyID');
                    this.UserID = localStorage.getItem('UserID');
                    this.employeeId = localStorage.getItem('EmployeeId');
                    if (IsDayStartOn == 'true') {
                        var root = this;
                        this.isDayAlreadyStart = true;
                        root.getBank();

                        root.getCurrency();
                        root.GetCategoryData(root.search, true);
                        root.invoiceWoInventory = localStorage.getItem('InvoiceWoInventory');
                        if (root.$route.query.data == undefined) {
                            root.sale.date = moment().format("LLL");
                            root.sale.dueDate = moment().format("LLL");
                        }
                        root.AutoIncrementCode();
                        if (root.$route.query.data != undefined) {
                            root.warehouse = root.$route.query.data;
                        }
                        if (root.$route.query.mobiledata != undefined) {
                            root.sale.date = root.$route.query.mobiledata.orderDate;
                        }
                        root.changePriceDuringSale = localStorage.getItem('changePriceDuringSale');
                        root.changePriceDuringSale == 'true' ? (root.changePriceDuringSale = true) : (root.changePriceDuringSale = false);
                        root.giveDiscountDuringSale = localStorage.getItem('giveDicountDuringSale');
                        root.giveDiscountDuringSale == 'true' ? (root.giveDiscountDuringSale = true) : (root.giveDiscountDuringSale = false);
                        root.GetDenominationSetupData();
                        root.CounterDetail();
                    }
                    else {
                        this.isDayAlreadyStart = false;
                    }
                }
            }
            this.GetProductList();

            this.sale.barCode = Math.floor(Math.random() * 100000000000);
        },

    }
</script>
<style scoped>
    .calculator-wraper div button {
        background-color: #3178F61A;
        color: #3178F6;
        border-color: #3178F61A;
        padding: 10px 20px;
        border-radius: 3px !important;
    }
        .calculator-wraper div button:focus, .calculator-wraper div button:active {
            background-color: #3178F61A !important;
            color: #3178F6 !important;
            border-color: #3178F61A !important;
            padding: 10px 20px !important;
            border-radius: 3px !important;
        }

    .denomination-wraper div button {
        background-color: #F2F2F2;
        color: #000000;
        border-color: #F2F2F2;
        padding: 10px 20px;
        border-radius: 3px !important;
    }

        .denomination-wraper div button:hover, .denomination-wraper div button:active, .denomination-wraper div button:focus {
            background-color: #E0E0E0 !important;
            color: #000000 !important;
            border-color: #E0E0E0 !important;
            padding: 10px 20px;
            border-radius: 3px !important;
        }

    .bg_color {
        background-color: rgb(45, 118, 247) !important;
        color: #ffffff !important;
    }

    .cardHover:hover {
        background-color: #2d76f7 !important;
        cursor: pointer;
        color: white !important;
        border-radius: 0 !important;
    }

    .cardHoverreturn:hover div div {
        background-color: #2d76f7 !important;
        cursor: pointer;
        color: white !important;
        border-radius: 0 !important;
    }

    .cardHover:hover div img {
        filter: none !important;
    }

    .cardHover:hover, .item-list-name {
        color: white;
    }

    .hoverColour:hover, .hoverColour:focus, .hoverColour:active {
        background-color: rgb(159 28 67) !important;
    }

    .cardHover {
        color: white;
        border-radius: 0 !important;
    }

    .bluecolorfor {
        color: white;
        background-color: #2d76f7 !important;
    }

    .bluecolorforcategory {
        color: white;
        background-color: #2d76f7 !important;
        border-radius: 18px;
    }

    .product {
        color: black;
    }

    .cardClass:hover {
        background-color: #2d76f7;
        width: 100%;
        border-radius: 18px;
        cursor: pointer;
        color: white;
    }

    .brown_color {
        background-color: #35353D;
    }

    .brown_color_Upper_div {
        background-color: #3b3b4d;
    }

    .white_color {
        background-color: #FFFFFF;
    }

    .white {
        color: !important #FFFFFF;
    }

    .grey_color {
        background-color: #F6F6F6;
    }

    .has-search .form-control {
        border: none;
        padding-left: 1.375rem;
    }

    .has-search .form-control-feedback {
        border: none;
        position: absolute;
        z-index: 2;
        display: block;
        width: 1.375rem;
        height: 2.375rem;
        line-height: 2.375rem;
        pointer-events: none;
        color: #aaa;
    }
    /*.search-invoice {
        border: none;
        position: absolute;
        z-index: 2;
        display: block;
        width: 1.375rem;
        height: 2.375rem;
        line-height: 2.375rem;
        pointer-events: none;
        color: #aaa;
    }*/

    .crossoverlay {
        position: absolute;
        bottom: 0;
        left: 100%;
        right: 0;
        background-color: white;
        overflow: hidden;
        width: 0;
        height: 100%;
        transition: .5s ease;
    }

    .col-padding-remove {
        padding-left: 5px;
        padding-right: 5px;
    }
    /*.form-control[disabled] {
        background-color: transparent;
        border: none;
        color: #ffffff;
    }*/
    .tbl_border th {
        padding: 12px 5px;
    }

    .tbl_border td {
        padding: 12px 5px;
    }

    .qty-input {
        background-color: transparent !important;
        border: none !important;
        width: 100% !important;
        padding-left: 3px;
        padding-right: 3px;
    }

    .ellipse {
        white-space: nowrap;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .two-lines {
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        white-space: normal;
    }

    .resetHover:hover {
        background-color: red !important;
    }
</style>
<style>
    .inv_search .multiselect__tags, .inv_search .multiselect__tags input, .inv_search .multiselect__tags .multiselect__single {
        background-color: transparent !important;
    }

    .inv_search .multiselect__select {
        display: none;
    }
</style>